
import * as jnb from 'react-bootstrap';
import { ErrorMessage, Field, FieldArray, FormikProvider, useFormik } from 'formik';
import { BiTrash } from 'react-icons/bi';
import React, { useEffect, useRef, useState } from 'react';
import { BsChevronDown, BsEye } from 'react-icons/bs';
import { VscDiffAdded } from 'react-icons/vsc';
import Sweetalert, { failureAlert } from '../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { config } from '../../CommonUtils/CommonUrl/CommonUrls';
import PublicHeader from '../../Header/PublicHeader';
import { FaDownload, FaEye, FaEyeSlash, FaHandPointRight, FaPrint } from 'react-icons/fa';
import axios from 'axios';
import { allowCharsAndNumericMaxSpaces, handleKeyAlphaNumeric, handleKeyPressAlphabets, handleKeyPressNumeric, public_url } from '../../CommonUtils/Validations/RegularExpAndVar';
import ImageBucket, { EmpanelImageBucket, ImageBucket_PHOTOS } from '../../CommonUtils/CommonFileUpload/ImageBucket';
import { WorkerRegValidations } from '../../CommonUtils/Validations/Validations';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios/CommonAxios';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import { useNavigate } from "react-router-dom"
import SecureImage from '../../CommonUtils/CommonFileUpload/SecureImage';
import { ViewImage } from '../../CommonUtils/CommonFileUpload/ViewImage';



export default function WorkerRegistrationForm() {
    const navigate = useNavigate();
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    // const [selectedImage, setSelectedImage] = useState(null);
    const [showSubCasteList, setSubCasteList] = useState([]);
    const [showCasteList, setCasteList] = useState([]);
    const [showList, setList] = useState([]);
    // ***** Districts for all  **
    const [showDist, setDist] = useState([])
    // ****** Presental address ****************
    const [showPresentalManList, setPresentalManList] = useState([]);
    const [showPresentDistCode, setPresentDistCode] = useState("");
    const [showPresentVillList, setPresentVillList] = useState([]);
    // ******************************** Permanent address ************************************ ******* */
    const [showPermntManList, setPermntManList] = useState([]);
    const [showPermntDistCode, setPermntDistCode] = useState("");
    const [showPermntVillList, setPermntVillList] = useState([]);
    //******************* */ office Address ****************** 
    const [showOfficeManList, setOfficeManList] = useState([]);
    const [showOfficeDistCode, setOfficeDistCode] = useState("");
    const [showOfficeVillList, setOfficeVillList] = useState([]);

    const [showmigrantManList, setmigrantManList] = useState([]);
    const [showmigrantDistCode, setmigrantDistCode] = useState("");
    const [showmigrantVillList, setmigrantVillList] = useState([]);
    const [perList, setPerList] = useState([]);

    const [showData, setData] = useState([])
    const [scode, setScode] = useState(null);
    const [ShowTxnHistory, setTxnHistory] = useState([])

    const [ageText, setAgeText] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    // const handleView = (image) => {
    //     setSelectedImage(image);
    // };

    //const [agee, setAgee] = useState('');

    const [previewMode, setPreviewMode] = useState(false);
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails);
    let location = useLocation()
    let RegisteredStatus = location?.state?.status
    let username = location?.state?.username
    let userType = loginreducer?.userType;
    const workerId = userType === 'emp' ? '0' : loginreducer?.loginData?.usr_id;
    // const date = maxxDate.toISOString().split('T')[0];

    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            entryBy: username ? username : "Open",
            registeredBy: RegisteredStatus ? RegisteredStatus : "OWN",
            aadhaarNo: userType === 'emp' ? '' : loginreducer?.loginData?.aadhar,
            workerName: (showData?.first_name + showData?.last_name) || "",
            religion: showData?.religion || "",
            caste: showData?.caste_code || "",
            subCaste: showData?.sub_caste || "",
            dob: showData?.dob || (userType === 'emp' ? '' : loginreducer?.loginData?.dob),

            phoneNo: showData?.phone_no || (userType === 'emp' ? '' : loginreducer?.loginData?.mobile),
            fatherName: showData?.father_name || (userType === 'emp' ? '' : loginreducer?.loginData?.father_name),

            isPermanent: showData?.is_permanent || "",

            // ---------------- PRESENT ADDRESS ----------------
            presentDistrictCode: showData?.present_district_code || "",
            presentMadalCode: showData?.present_mandal_code || "",
            presentVillageCode: showData?.present_village_code || '',
            presentOtherVillageName: showData?.present_other_village_name || "",
            presentPincode: showData?.present_pincode || "",
            presentDoorNo: showData?.present_door_no || "",
            presentAddress: showData?.present_address || "",
            presentCity: showData?.present_city || "",
            presentLandMark: showData?.present_land_mark || "",
            presentDivision: showData?.present_division || "",

            // ---------------- PERMANENT ADDRESS ----------------
            permanentDistrictCode: showData?.permanent_district_code || "",
            permanentMadalCode: showData?.permanent_mandal_code || "",
            permanentVillageCode: showData?.permanent_village_code || "",
            permanentOtherVillageName: showData?.permanent_other_village_name || "",
            permanentPincode: showData?.permanent_pincode || "",
            permanentDoorNo: showData?.permanent_door_no || "",
            permanentAddress: showData?.permanent_address || "",
            permanentCity: showData?.permanent_city || "",
            permanentLandMark: showData?.permanent_land_mark || "",
            permanentDivision: showData?.permanent_division || "",

            isNregs: showData?.is_nregs || "",
            jobCardNo: showData?.job_card_no || "",

            wordDaysCopyDesc: showData?.word_days_copy_desc || "",

            // ---------------- FAMILY DETAILS ----------------
            familydetails: showData?.fam_details?.map(item => ({
                relation: item?.relation || "",
                memberName: item?.member_name || "",
                memberDob: item?.member_dob || "",
                memberUid: item?.member_uid || "",
                isNomine: item?.is_nominee || "",
                nominePer: item?.nominee_percentage || ""
            })) || [
                    {
                        relation: "",
                        memberName: "",
                        memberDob: "",
                        memberUid: "",
                        isNomine: "",
                        nominePer: ""
                    },
                ],

            isUnionMember: showData?.is_union_member || "",
            unionName: showData?.union_name || "",
            regNo: showData?.reg_no || "",
            presentOfficeName: showData?.present_office_name || "",
            typeOfWork: showData?.type_of_work || "",
            workCapability: showData?.work_capability || "",

            officeDistrictCode: showData?.office_district_code || "",
            officeMadalCode: showData?.office_mandal_code || "",
            officeVillageCode: showData?.office_village_code || "",
            officeOtherVillageName: showData?.office_other_village_name || "",
            officePincode: showData?.office_pincode || "",
            officeDoorNo: showData?.office_door_no || "",
            officeAddress: showData?.office_address || "",

            isMigrant: showData?.is_migrant || "",
            lastName: showData?.last_name || "",
            firstName: showData?.first_name || (userType === 'emp' ? '' : loginreducer?.loginData?.full_name),
            gender: showData?.gender || "",
            maritalStatus: showData?.marital_status || "",

            empName: showData?.emp_name || "",

            photoDesc: showData?.upload_photo || "",
            aadhaarPhotoDesc: showData?.upload_aadhaar_photo || "",
            selfAffidavitDesc: showData?.upload_self_affidavit || "",

            ifscCode: showData?.ifsc_code || "",
            bankName: showData?.bank_name || "",
            bankAccountNo: showData?.bank_account_no || "",
            rbankAccountNo: showData?.bank_account_no || "",
            nameInBank: showData?.name_in_bank || "",
            bankPhotoDesc: showData?.upload_bank_photo || "",
            branchName: showData?.branch_name || "",
            workYears: showData?.work_year ? "1" : "",
            amount: showData?.amount || "0",
            selfCheck: showData?.length !== 0 ? true : false,
            renewalamount: 12,
        },
        onSubmit: (values) => {
            setShowPreviewModal(true);
            console.log("values", JSON.stringify(values));

        },
        validateOnChange: true,
        context: { aadhaarNo: '', dob: '', },
        validationSchema: WorkerRegValidations
    })

    useEffect(() => {
        Formik.setFormikState(prevState => ({
            ...prevState,
            context: {
                ...prevState.context,
                aadhaarNo: Formik.values.aadhaarNo
            }
        }));
    }, [Formik.values.aadhaarNo]);
    function getBanksFunction(ifsc_code) {
        if (ifsc_code !== undefined) {
            let banksUrl = (config.url.BOC_URL + public_url + "rbibanks/?ifscCode=" + ifsc_code);
            axios.get(banksUrl).then((response) => {
                if (response?.data?.status === true) {
                    //Formik.setFieldValue("ifscCode", response?.data?.Banks?.ifsc_code)
                    Formik.setFieldValue("bankName", response?.data?.Banks?.bankname);
                    Formik.setFieldValue("branchName", response?.data?.Banks?.branch_name)

                }
                else if (response.data.status === false) {
                    failureAlert("Invalid IFSC Code , Please enter valid one", "error");
                    Formik.setFieldValue("ifscCode", "")
                    Formik.setFieldValue("bankName", "")
                    Formik.setFieldValue("branchName", "")
                }
            })
        }
    }



    const submitvalues = (values) => {
        let data = values?.familydetails;
        let per = 0;

        for (let item of data) {
            if (item.nominePer !== "") {
                per += parseInt(item.nominePer);
            }
        }
        // Helper to handle payment form submission
        const handlePayment = (res) => {
            let { encrypted_string: resData, merchant_id: merchantId } = res.data;
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = "https://test.epay.sbiuat.bank.in/secure/AggregatorHostedListener";

            const createInput = (name, value) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                input.id = name;
                input.value = value;
                form.appendChild(input);
            };

            createInput('merchIdVal', merchantId);
            createInput('EncryptTrans', resData);

            document.body.appendChild(form);
            form.submit();
        };
        // Helper for common registration call
        const registerWorker = (url, payload) => {
            CommonAxiosPost(url, payload)
                .then((res) => {
                    if (res.data?.scode === '01') {
                        let payUrl = config.url.BOC_URL + "pay";
                        CommonAxiosGet(payUrl).then((response) => {
                            if (response.data.status === false) {
                                navigate("/PaymentPage");
                            } else {
                                handlePayment(res);
                            }
                        }).catch((error) => {
                            console.log("Error during payment request:", error);
                        });
                    } else if (res.data.scode === '02' || res.data.scode === '03') {
                        failureAlert(res.data.sdesc, 'warning');
                    }
                })
                .catch((error) => {
                    console.log("Error at BOC worker registration:", error);
                });
        };
        if (per !== 100) {
            Sweetalert("% of Benefits in Family must be equal to 100", 'warning');
        } else {
            if (RegisteredStatus === "ALO") {
                registerWorker(config.url.BOC_URL + "worker-registration", values);
            } else if (showData?.renewal === true) {
                registerWorker(config.url.BOC_URL + "worker-registration-renewal", {
                    ...values,
                    workerId: showData?.worker_id
                });
            } else {
                registerWorker(config.url.BOC_URL + "worker-registration", values);
            }
        }
    };
    /****************CLEAR FUNCTION *********************/
    function clrBankName() {
        Formik.setFieldValue("bankName", "");
    }
    function clrsubBranchName() {
        Formik.setFieldValue("branchName", "");
    }


    function GetCasteSubCaste() {
        let url = config.url.BOC_URL + public_url + "castesubcaste";
        axios.get(url).then((res) => {
            if (res.data.status === true) {
                setList(res.data)
            }
        })
    }
    function GetCaste(e) {
        Formik.setFieldValue("subCaste", "");
        Formik.setFieldValue("caste", "");
        if (e?.target?.value !== "") {
            setCasteList(showList?.castes?.filter((relVal) => relVal.religion === (e?.target?.value || showData?.religion)))
        }
    }
    function GetSubcaste(e) {
        Formik.setFieldValue("subCaste", "");
        if (e?.target?.value !== "") {
            setSubCasteList(showList.sub_castes?.filter((Val) => Val.caste_code === parseInt(e?.target?.value)));
        }
    }
    /************************************************** Districts for all  ************************************ ******* */
    // const [showDist, setDist] = useState([])
    // const getDistDataFunction = () => {
    //     let url = config.url.BOC_URL + public_url + "listofstates";
    //     axios.get(url).then((response) => {
    //         setDist(response.data.districts);
    //     })
    // };
    const getDistDataFunction = () => {
        let url = config.url.BOC_URL + public_url + "listofdistricts";
        axios.get(url).then((response) => {
            setDist(response.data.districts);
        })
    };
    /************************************************** Presental address ************************************ ******* */

    // const getPresentMandalFunction = (e) => {
    //     setPresentDistCode(e.target.value);
    //     setPresentalManList(showDist.filter((val) => val.districtId === e.target.value)[0].mandals)
    // };
    const getPresentMandalFunction = (input) => {
        let selectedDistId;
        if (typeof input === "object" && input?.target?.value) {
            selectedDistId = parseInt(input.target.value);
        } else if (typeof input === "string" || typeof input === "number") {
            selectedDistId = parseInt(input);
        } else {
            console.error("Invalid input to getPresentMandalFunction");
            return;
        }
        setPresentDistCode(selectedDistId);
        const selectedDist = showDist.find((val) => val.districtId === selectedDistId);
        if (selectedDist && selectedDist.mandals) {
            setPresentalManList(selectedDist.mandals);
        } else {
            setPresentalManList([]);
        }
    };

    // new-villages?dist_code=502&mandal_code=4689
    const getPresentVillageDataFunction = (e) => {
        const mandalCode = e?.target?.value || e;
        if (mandalCode === "") {
            setPresentVillList([]);
            Formik.setFieldValue('presentVillageCode', showData?.present_village_code || '');
            return;
        }
        if (showPresentDistCode) {
            let url = config.url.BOC_URL + public_url + "new-villages?dist_code=" + showPresentDistCode + "&mandal_code=" + mandalCode;
            axios.get(url).then((response) => {
                setPresentVillList(response.data?.villages);
            }).catch((error) => {
                console.error("Error fetching villages:", error);
                setPresentVillList([]);
            });
        }
    };

    /************************************************** Permanent address ************************************ ******* */
    // const getPermanentMandalFunction = (e) => {
    //     setPermntDistCode(e.target.value);
    //     setPermntManList(showDist.filter((val) => val.districtId === e.target.value)[0].mandals)
    // };

    const getPermanentMandalFunction = (input) => {
        let selectedDistId;
        if (typeof input === "object" && input?.target?.value) {
            selectedDistId = parseInt(input.target.value);
        } else if (typeof input === "string" || typeof input === "number") {
            selectedDistId = parseInt(input);
        } else {
            console.error("Invalid input to getPresentMandalFunction");
            return;
        }
        setPermntDistCode(selectedDistId);
        const selectedDist = showDist.find((val) => val.districtId === selectedDistId);
        if (selectedDist && selectedDist.mandals) {
            setPermntManList(selectedDist.mandals);
        } else {
            setPermntManList([]);
        }
    };

    const getPermntVillageDataFunction = (e) => {
        const mandalcode = e?.target?.value || e;
        if (mandalcode === "") {
            setPermntVillList([]);
            Formik.setFieldValue('permanentVillageCode', showData?.permanent_village_code || '');
            return;
        }
        if (showPermntDistCode) {
            let villUrl = config.url.BOC_URL + public_url + "new-villages?dist_code=" + showPermntDistCode + "&mandal_code=" + mandalcode;
            axios.get(villUrl).then((response) => {
                setPermntVillList(response.data?.villages);
            }).catch((error) => {
                console.error("Error fetching villages:", error);
                setPermntVillList([]);
            });
        }
    };
    /************************************************** Office address ************************************ ******* */

    // const getOfficeMandalFunction = (e) => {
    //     setOfficeDistCode(e.target.value);
    //     setOfficeManList(showDist.filter((val) => val.districtId === e.target.value)[0].mandals)
    // };

    const getOfficeMandalFunction = (input) => {
        let selectedDistId;
        if (typeof input === "object" && input?.target?.value) {
            selectedDistId = parseInt(input.target.value);
        } else if (typeof input === "string" || typeof input === "number") {
            selectedDistId = parseInt(input);
        } else {
            console.error("Invalid input to getPresentMandalFunction");
            return;
        }
        setOfficeDistCode(selectedDistId);
        const selectedDist = showDist.find((val) => val.districtId === selectedDistId);
        if (selectedDist && selectedDist.mandals) {
            setOfficeManList(selectedDist.mandals);
        } else {
            setOfficeManList([]);
        }
    };

    const getOfficeVillageDataFunction = (e) => {
        const MandalCode = e?.target?.value || e;
        if (MandalCode === "") {
            setOfficeVillList([]);
            Formik.setFieldValue('officeVillageCode', showData?.office_village_code || '');
            return;
        }
        if (showOfficeDistCode) {
            let villUrl = config.url.BOC_URL + public_url + "new-villages?dist_code=" + showOfficeDistCode + "&mandal_code=" + MandalCode;
            axios.get(villUrl).then((response) => {
                setOfficeVillList(response.data?.villages);
            }).catch((error) => {
                console.error("Error fetching villages:", error);
                setOfficeVillList([]);
            });
        }
    };


    const getmigrantMandalFunction = (e) => {
        setmigrantDistCode(e.target.value);
        setmigrantManList(showDist.filter((val) => val.districtId === e.target.value)[0].mandals)
    };
    const getmigrantVillageDataFunction = (e) => {
        let villUrl = config.url.BOC_URL + public_url + "villagenew/?distCode=" + showmigrantDistCode + "&&mandalCode=" + e.target.value;
        axios.get(villUrl).then((response) => {
            setmigrantVillList(response.data?.APCFSS_villages);
        });
    };








    /************************************************** Percentage address ************************************ ******* */
    const PerCal = () => {
        const perListValues = [];
        for (let i = 5; i < 105; i += 5) {
            perListValues.push(i);
        }
        return perListValues;
    }



    function getDataFunction() {
        let url = config.url.BOC_URL + "workerreg?userId=" + workerId;
        CommonAxiosGet(url).then((response) => {
            setScode(response.data.scode);
            if (response.data.status === true) {
                const workerData = response.data.workerReg[0];
                // Parse fam_details
                const familyDetails = JSON.parse(workerData.fam_details || "[]");
                workerData.fam_details = familyDetails; // Replace with parsed array
                const PaymentHistory = JSON.parse(workerData?.payment_history || "[]");
                const TransactionHistory = PaymentHistory?.[0]?.transaction_history;
                setTxnHistory(TransactionHistory)
                setData(workerData);
            } else {
                setData([]);
            }
        });
    }

    const payment = (values) => {
        const payload = {
            // workerId: showData?.worker_id,
            // aadhaarNo: showData?.aadhaar_no,
            // phoneNo: showData?.phone_no,
            // amount: showData?.amount
            userId: loginreducer?.loginData?.usr_id
        }

        CommonAxiosPost(config.url.BOC_URL + "worker-payment", payload)
            .then((res) => {
                if (res.data?.scode === '01') {
                    let url = config.url.BOC_URL + "pay";
                    CommonAxiosGet(url).then((response) => {

                        if (response.data.status === false) {
                            navigate("/PaymentPage");
                        }
                        else {
                            let resData = res.data.encrypted_string;
                            let merchantId = res.data.merchant_id;

                            const form = document.createElement('form');
                            form.method = 'POST';
                            form.action = "https://test.epay.sbiuat.bank.in/secure/AggregatorHostedListener";
                            // form.action = "https://test.sbiepay.sbi/secure/AggregatorHostedListener";

                            const inputMerchantId = document.createElement('input');
                            inputMerchantId.type = 'hidden';
                            inputMerchantId.name = 'merchIdVal';
                            inputMerchantId.id = 'merchIdVal';
                            inputMerchantId.value = merchantId;
                            form.appendChild(inputMerchantId);

                            const inputEncryption = document.createElement('input');
                            inputEncryption.type = 'hidden';
                            inputEncryption.name = 'EncryptTrans';
                            inputEncryption.id = 'EncryptTrans';
                            inputEncryption.value = resData;
                            form.appendChild(inputEncryption);

                            document.body.appendChild(form);
                            form.submit();
                        }
                    })
                        .catch((error) => {
                            console.log("Error during payment request:", error);
                        });
                } else if (res.data.scode === '02' || res.data.scode === '03') {
                    failureAlert(res.data.sdesc, 'warning');
                }
            })
            .catch((error) => {
                console.log("Error at BOC worker registration:", error);
            });

    }
    useEffect(() => {
        GetCasteSubCaste()
        setPerList([...PerCal()]);
        getDistDataFunction()
        getDataFunction()
    }, []);

    useEffect(() => {
        const presentDistCode = showData?.present_district_code;
        const presentMandalCode = showData?.present_mandal_code;
        const presentVillageCode = showData?.present_village_code;

        const permanentDistrictCode = showData?.permanent_district_code;
        const permanentMadalCode = showData?.permanent_mandal_code;
        const permanentVillageCode = showData?.permanent_village_code;

        const officeDistrictCode = showData?.office_district_code;
        const officeMadalCode = showData?.office_mandal_code;
        // const officeVillageCode = showData?.office_village_code;

        const religion = showData?.religion;
        const casteCode = showData?.caste_code;
        const subCasteCode = showData?.sub_caste;

        if (casteCode) {
            GetCaste({ target: { value: religion } })
            Formik.setFieldValue("caste", casteCode);
            console.log("subcastecode", subCasteCode)
            if (subCasteCode) {
                GetSubcaste({ target: { value: casteCode } });
                Formik.setFieldValue("subCaste", subCasteCode);
            }
        }
        if (presentDistCode) {
            Formik.setFieldValue("presentDistrictCode", presentDistCode);
            getPresentMandalFunction(presentDistCode);
            if (presentMandalCode) {
                Formik.setFieldValue("presentMadalCode", presentMandalCode);
                getPresentVillageDataFunction(presentMandalCode)
                if (presentVillageCode) {
                    Formik.setFieldValue("presentVillageCode", presentVillageCode);
                }
            };
        }
        if (permanentDistrictCode) {
            Formik.setFieldValue("permanentDistrictCode", permanentDistrictCode);
            getPermanentMandalFunction(permanentDistrictCode);
            if (permanentMadalCode) {
                Formik.setFieldValue("permanentMadalCode", permanentMadalCode);
                getPermntVillageDataFunction(permanentMadalCode)
                if (permanentVillageCode) {
                    Formik.setFieldValue("permanentVillageCode", permanentVillageCode);
                }
            };
        }
        if (officeDistrictCode) {
            Formik.setFieldValue("officeDistrictCode", officeDistrictCode);
            getOfficeMandalFunction(officeDistrictCode);
            if (officeMadalCode) {
                Formik.setFieldValue("officeMadalCode", officeMadalCode);
                getOfficeVillageDataFunction(officeMadalCode)
                // if (officeVillageCode) {
                //     Formik.setFieldValue("officeVillageCode", officeVillageCode);
                // }
            };
        }
    }, [showData])
    let componentRef = useRef();
    // const latestTab = useSelector((state) => state.reducers.loginreducer.tabdetails.latestTab);
    const handleprint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "boc-Print",
    });

    const handlePreviewClick = () => {
        setPreviewMode(true);
    };

    const today = new Date();
    // 20 years ago = maximum date allowed
    const twentyYearsAgo = new Date(today.getFullYear() - 20, today.getMonth(), today.getDate());
    const maxDate = twentyYearsAgo.toISOString().split('T')[0];
    // 60 years ago = minimum date allowed
    const sixtyYearsAgo = new Date(today.getFullYear() - 60, today.getMonth(), today.getDate());
    const minDate = sixtyYearsAgo.toISOString().split('T')[0];

    const maxxDate = new Date();
    maxxDate.setFullYear(maxxDate.getFullYear() - 80);

    // Format the date in yyyy-mm-dd format (HTML input expects this format)
    const formattedMaxDate = maxxDate.toISOString().split('T')[0];

    //age 
    const calculateAge = (dob) => {
        if (!dob) return "";
        const today = new Date();
        const birthDate = new Date(dob);
        const age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth();
        // if (month < birthDate.getMonth() || (month === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
        //     return `${age - 1} years` ;
        // }
        // Calculate months and days
        let years = age;
        let months = month - birthDate.getMonth();
        let days = today.getDate() - birthDate.getDate();

        if (days < 0) {
            const previousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
            days += previousMonth.getDate();
            months -= 1;
        }

        if (months < 0) {
            months += 12;
            years -= 1;
        }

        return `${years} years ${months} months ${days} days`;
    };

    // Get the user's age from dob
    const ageString = Formik?.values.dob ? calculateAge(Formik.values.dob) : null;

    // Extract years from ageString only if it's a string
    const Age = typeof ageString === "string" ? parseInt(ageString.split(" ")[0], 10) : null;

    const ageList = ageString ? ageString.split(" ") : null;

    // Determine the options based on age
    let options = [];
    if (Age !== null) {
        if (Age < 55) {
            options = [1, 2, 3, 4, 5]; // For age 55 or below, show all options
        }
        else if (Age === 55 && (ageList[2] > 0 || (ageList[4] > 0))) {
            options = [1, 2, 3, 4];
        }
        else if (Age === 56 && (ageList[2] == 0 && ageList[4] == 0)) {
            options = [1, 2, 3, 4];
        }
        else if (Age === 56 && (ageList[2] > 0 || ageList[4] > 0)) {
            options = [1, 2, 3];
        }
        else if (Age === 57 && (ageList[2] == 0 && ageList[4] == 0)) {
            options = [1, 2, 3];
        }
        else if (Age === 57 && (ageList[2] > 0 || ageList[4] > 0)) {
            options = [1, 2];
        }
        else if (Age === 58 && (ageList[2] == 0 && ageList[4] == 0)) {
            options = [1, 2];
        }
        else if (Age === 58 && (ageList[2] > 0 || ageList[4] > 0)) {
            options = [1];
        }
        else if (Age === 59 && (ageList[2] == 0 && ageList[4] == 0)) {
            options = [1];
        }
    }
    const handleYearChange = (event) => {
        const selectedYear = parseInt(event.target.value, 10); // convert to number
        const baseAmount = 50;

        let amount = 0;

        if (selectedYear > 0) {
            amount = baseAmount + (12 * selectedYear);
        }

        Formik.setFieldValue('amount', amount);
    };

    // const handleYearChange = (event) => {
    //     const selectedYear = event.target.value;
    //     const baseAmount = 62;

    //     // Calculate amount based on year selected
    //     const amount = selectedYear ? baseAmount * selectedYear : 0;

    //     // Update the Formik 'amount' field dynamically
    //     Formik.setFieldValue('amount', amount);
    // };
    //const initialDob = userType === 'emp' ? Formik.values.dob : loginreducer?.loginData?.dob || '';

    //  useEffect(() => {
    //     if (initialDob) {
    //       setAgeText(calculateAge(initialDob));
    //       // Also sync Formik dob if not emp
    //       if (userType !== 'emp' && Formik.values.dob !== initialDob) {
    //         Formik.setFieldValue('dob', initialDob);
    //       }
    //     } else {
    //       setAgeText('');
    //     }
    //   }, [initialDob, Formik, userType]);

    // Determine file paths (prefer showData, fallback to Formik)
    const filePaths = {
        noOfworkdays: showData?.word_days_copy || Formik?.values?.wordDaysCopyDesc,
        bankPhoto: showData?.upload_bank_photo || Formik.values.bankPhotoDesc,
        photo: showData?.upload_photo || Formik.values.photoDesc,
        adhaar: showData?.upload_aadhaar_photo || Formik.values.aadhaarPhotoDesc,
        affidavit: showData?.upload_self_affidavit || Formik.values.selfAffidavitDesc

    };
    return (
        <React.Fragment>
            <PublicHeader />
            <div className="main_section"> </div>
            {/* <CommonPageHeading heading={scode === "01" ? "Print Application for Worker Registration Form" : "Registration Form for Workers "}/> */}
            {/* <CommonPageHeading heading="Registration Form for Workers(కార్మికుల కోసం నమోదు ఫారం) " /> */}
            <jnb.Container className="mt-1">
                <jnb.Row>
                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between px-0">
                        <div className="inner-herbpage-service-title1">
                            <h1>{showData?.renewal === true ? "Renewal" : "Registration"} Form for Workers(కార్మికుల కోసం నమోదు ఫారం)</h1>
                        </div>
                        <div className="text-right">
                            <button className="btn btn-secondary btn-sm" onClick={() => {
                                if (userType === 'emp') {
                                    navigate('/WorkerRegistrationReport');
                                } else if (userType === 'user') {
                                    navigate('/DashBoardMain');
                                } else {
                                    navigate(-1);
                                }
                            }}>Back</button>
                        </div>
                    </jnb.Col>
                </jnb.Row>
            </jnb.Container>
            <jnb.Container className="outer-page-content-container" >
                <FormikProvider value={Formik}>
                    <jnb.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust" id="form-start">
                        {(scode === "03" || (scode === "01" && showData?.renewal === true)) && (
                            <>
                                <div className="form-card-jnb" >
                                    <h5 style={{ textAlign: 'center', whiteSpace: 'pre-line', color: '#074079' }} >
                                        <strong>
                                            ఆంధ్ర ప్రదేశ్ భవన మరియు ఇతర నిర్మాణ రంగ కార్మికుల నిబంధనలు, 1999 రూల్ 33ఏ (2){"\n"} భవన మరియు ఇతర నిర్మాణ కార్మికునిగా రిజిస్టర్ చేసుకొనుటకు దరఖాస్తు.
                                        </strong>
                                    </h5>
                                    <jnb.Row className="pt-3">
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="">
                                                <label>Aadhaar No(ఆధార్ సంఖ్య)</label>
                                                <Field type="text" autoComplete="off" className="form-control w-100 mt-4" name="aadhaarNo" maxLength={12}
                                                    disabled={userType === 'emp' ? false : true}
                                                    onKeyPress={(e) => handleKeyPressNumeric(e)}
                                                    // disabled={showData?.renewal === true}
                                                    title="Enter your Aadhaar No (మీ ఆధార్ సంఖ్యను నమోదు చేయండి)"
                                                />
                                                {userType === 'emp' && (
                                                    <ErrorMessage name="aadhaarNo" component="div" className="text-error" />
                                                )}

                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="">
                                                <label> First Name(మొదటి పేరు)</label>
                                                <Field type="text" autoComplete="off" className="form-control w-100 mt-4 mb-3" name="firstName"
                                                    onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                                    maxLength='25'
                                                    // placeholder="మొదటి పేరును నమోదు చేయండి"
                                                    disabled={userType === 'emp' ? false : true}
                                                    title="Enter your First Name(మీ మొదటి పేరును నమోదు చేయండి)"
                                                />
                                                <ErrorMessage name="firstName" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="">
                                                <label> Last(Sur) Name(చివరి పేరు / ఇంటి పేరు)</label>
                                                <Field type="text" autoComplete="off" className="form-control w-100 mt-1" min="3" name="lastName"
                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                                    onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                    maxLength='25'
                                                    disabled={showData?.renewal === true}
                                                    title="Enter your Last Name(మీ చివరి పేరు నమోదు చేయండి)"
                                                />
                                                <ErrorMessage name="lastName" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <label> Gender(లింగం)</label>
                                            <jnb.InputGroup className="form-control" title=" select your gender(మీ లింగాన్ని ఎంచుకోండి)">
                                                <Field type="radio" autoComplete="off" name="gender" value="M" disabled={showData?.renewal === true}
                                                /> &nbsp; Male(పురుషుడు) &nbsp;
                                                <Field type="radio" autoComplete="off" name="gender" value="F" disabled={showData?.renewal === true} />&nbsp;Female(స్త్రీ) &nbsp;
                                                <Field type="radio" autoComplete="off" name="gender" value="T" disabled={showData?.renewal === true} />&nbsp;Transgender(ట్రాన్స్‌జెండర్)
                                            </jnb.InputGroup>
                                            <ErrorMessage name="gender" component="div" className="text-error" />
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                            <jnb.InputGroup className="">
                                                <label>Marital Status(వివాహ స్థితి)</label>
                                                <Field as="select" autoComplete="off" name="maritalStatus" className="form-control w-100 mt-1"
                                                    title="Select your marital status (మీ వివాహ స్థితిని ఎంచుకోండి)" disabled={showData?.renewal === true}
                                                >
                                                    <option value="">----Select-----</option>
                                                    <option value="Single">Single (అవివాహిత)</option>
                                                    <option value="Married">Married (వివాహిత)</option>
                                                    <option value="Divorced">Divorced (విభజిత)</option>
                                                    <option value="Widower">Widower (విధూరుడు)</option>
                                                    <option value="Widow">Widow (విధవ)</option>
                                                </Field>
                                                <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                <ErrorMessage name="maritalStatus" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                            <jnb.InputGroup className="">
                                                <label>Religion (మతం)</label>
                                                <Field as="select" autoComplete="off" name="religion" className="form-control w-100 mt-1" onChange={(e) => {
                                                    GetCaste(e)
                                                }} disabled={showData?.renewal === true}
                                                    title="select your Religion(మీ మతం ఎంచుకోండి)"
                                                >
                                                    <option value="">----Select-----</option>
                                                    {showList !== undefined && showList?.religions?.map((cs, i) => {
                                                        return (<option key={i} value={cs.religionid}>{cs.religiondesc}</option>
                                                        );
                                                    })}
                                                </Field>
                                                <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                <ErrorMessage name="religion" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="">
                                                <label>Caste(కులం)</label>
                                                {showData?.caste_desc !== "" ? (
                                                    <>
                                                        <Field
                                                            as="select"
                                                            autoComplete="off"
                                                            className="form-control w-100 mt-1"
                                                            name="caste"
                                                            title="select your Caste(మీ కులం ఎంచుకోండి)"
                                                            onChange={(e) => GetSubcaste(e)}
                                                            disabled={showData?.renewal === true}
                                                        >
                                                            <option value="">----Select-----</option>
                                                            {Array.isArray(showCasteList) &&
                                                                showCasteList.map((cs, i) => (
                                                                    <option key={i} value={cs.caste_code}>
                                                                        {cs.caste_desc}
                                                                    </option>
                                                                ))}
                                                        </Field>
                                                        <ErrorMessage name="caste" component="div" className="text-error" />
                                                    </>
                                                ) : (
                                                    <span>{showData?.caste_desc || "----Select-----"}</span>
                                                )}
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                            <jnb.InputGroup className="">
                                                <label>Sub Caste(ఉప కులం)</label>
                                                <Field as="select" autoComplete="off" name="subCaste" disabled={showData?.renewal === true} className="form-control w-100 mt-1" title="select your Sub Caste(మీ ఉప కులం ఎంచుకోండి)" >
                                                    <option value="">----Select-----</option>
                                                    {showSubCasteList !== undefined && showSubCasteList.map((scs, i) => {
                                                        return (<option key={i} value={scs.sub_caste_code}>{scs.sub_caste_desc}</option>);
                                                    })}
                                                </Field>
                                                <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                <ErrorMessage name="subCaste" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
                                            <jnb.InputGroup className="">
                                                <label>Phone No(ఫోన్ నంబర్)(Aadhar Linked Phone No)(ఆధార్‌కు లింక్ అయిన ఫోన్ నంబర్)</label>
                                                <Field type="text" autoComplete="off" className="form-control w-100 mt-2" name="phoneNo"
                                                    disabled={userType === 'emp' ? false : true}
                                                    // disabled = {showData?.renewal === false || scode === "03" }
                                                    maxLength="10" onKeyPress={(e) => handleKeyPressNumeric(e)}
                                                    title="Enter Your Phoneno(మీ ఫోన్ నంబర్ నమోదు చేయండి)"
                                                />
                                                <ErrorMessage name="phoneNo" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="">
                                                <label>DOB(పుట్టిన తేది)</label>
                                                <Field
                                                    type="date" autoComplete="off"
                                                    className="form-control w-100 mt-4"
                                                    name="dob"
                                                    value={Formik.values.dob}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    min={minDate}
                                                    max={maxDate}
                                                    // disabled={showData?.renewal === true}
                                                    title="select your DOB (మీ పుట్టిన తేది ఎంచుకోండి)"
                                                    disabled={userType === 'emp' ? false : true}
                                                    // onChange={(e) => {
                                                    //     const newDob = e.target.value;
                                                    //     Formik.setFieldValue('dob', newDob); // Update Formik

                                                    // }}
                                                    onChange={(e) => {
                                                        const newDob = e.target.value;
                                                        Formik.setFieldValue('dob', newDob);
                                                        Formik.setFieldValue('workYears', '');
                                                        Formik.setFieldValue('amount', 0);
                                                        if (newDob) {
                                                            setAgeText(calculateAge(newDob));
                                                        } else {
                                                            setAgeText('');
                                                        }
                                                    }}
                                                />
                                                {ageText && <div className="mt-2 text-highlight" style={{ color: 'blue', fontWeight: 'bold', marginTop: '0.5rem' }}>Age: {ageText}</div>}

                                                <ErrorMessage name="dob" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="">
                                                <label>Father /Husband Name(తండ్రి / భర్త పేరు)</label>
                                                <Field type="text" autoComplete="off" className="form-control w-100 mt-1" name="fatherName" disabled={userType === 'emp' ? false : true}
                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                                    onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                    maxLength='40'
                                                    title="Enter your Father /Husband Name (మీ తండ్రి/భర్త పేరు నమోదు చేయండి)"
                                                />
                                                {userType === 'emp' && (
                                                    <ErrorMessage name="fatherName" component="div" className="text-error" />
                                                )}
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                    </jnb.Row>
                                    <jnb.Row className="pt-1">
                                        <div className="inner-herbpage-service-title-sub mt-3 ">
                                            <h1>Family Details(కుటుంబ వివరాలు) <span style={{ fontSize: '17px' }}><b>(ఆంధ్ర ప్రదేశ్ భవన మరియు ఇతర నిర్మాణ రంగ కార్మికుల నిబంధనలు, 1999 రూల్ 33ఏ (5) నామినేషన్ పత్రము)</b></span></h1>
                                            {/* <span className="text-danger">(Wife is only determined as Nominee.In case of non-existence of wife, others may be nominated as Nominee)(భార్యను మాత్రమే నామినీగా నియమించబడుతుంది. భార్య లేకపోతే ఇతరులను నామినీగా నియమించవచ్చు.) </span> */}
                                        </div>
                                        <div className="table-responsive mt-2 mb-4">
                                            <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                                style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                                            >
                                                <thead >
                                                    <tr>
                                                        <th>Member Name (సభ్యుని పేరు)</th>
                                                        <th>Relation (బంధుత్వం)</th>
                                                        <th>Member Age (సభ్యుని పుట్టిన తేదీ)</th>
                                                        <th>Aadhaar No. (ఆధార్ సంఖ్య)</th>
                                                        <th>Is He/She Nominee (అతను/ ఆమె నామినీనా)? </th>
                                                        <th>% of Benefits? (ప్రయోజన శాతం?)</th>
                                                        <th>Add (చేర్చుటకోసమ) </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <FieldArray name="familydetails">
                                                        {(formikFieldArray) => {
                                                            return formikFieldArray.form.values.familydetails?.map((experienceDetails, index) => {
                                                                return (

                                                                    <tr key={index} id={index}>
                                                                        {/* <td>{experienceDetails?.relation}</td> */}
                                                                        <td>
                                                                            <jnb.InputGroup className="">
                                                                                <Field type="text" autoComplete="off" className="form-control" name={`familydetails[${index}].memberName`}
                                                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)} onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                                                    maxLength='40' disabled={showData?.renewal === true}
                                                                                    title="Enter your Family member Name(మీ కుటుంబ సభ్యుని పేరు నమోదు చేయండి)"
                                                                                />
                                                                                <ErrorMessage name={`familydetails[${index}].memberName`} component="div" className="text-error" /></jnb.InputGroup> </td>

                                                                        <td>
                                                                            <jnb.InputGroup className="">
                                                                                <Field as="select" autoComplete="off" className="form-control" name={`familydetails[${index}].relation`}
                                                                                    title="select your Family member Relation (మీ కుటుంబ సభ్యుని బంధుత్వం ఎంచుకోండి)" disabled={showData?.renewal === true}
                                                                                >
                                                                                    <option value="">---select---</option>
                                                                                    <option value="1">Mother (తల్లి)</option>
                                                                                    <option value="2">Father (తండ్రి)</option>
                                                                                    <option value="3">Brother (అన్న / తమ్ముడు)</option>
                                                                                    <option value="4">Sister (అక్క / చెల్లి)</option>
                                                                                    <option value="5">Grand Father (తాతయ్య)</option>
                                                                                    <option value="6">Grand Mother (అమ్మమ్మ / నానమ్మ)</option>
                                                                                    <option value="7">Spouse (జీవిత భాగస్వామి)</option>
                                                                                    <option value="8">Daughter (కుమార్తె)</option>
                                                                                    <option value="9">Son (కుమారుడు)</option>

                                                                                </Field>
                                                                                <ErrorMessage name={`familydetails[${index}].relation`} component="div" className="text-error" /></jnb.InputGroup> </td>
                                                                        <td>
                                                                            <jnb.InputGroup className="">
                                                                                <Field
                                                                                    type="date"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name={`familydetails[${index}].memberDob`}
                                                                                    max={new Date().toISOString().split("T")[0]} disabled={showData?.renewal === true}
                                                                                    onKeyDown={(e) => e.preventDefault()}
                                                                                    title="select your Family member DOB(మీ కుటుంబ సభ్యుని పుట్టిన తేదీ ఎంచుకోండి)"
                                                                                />
                                                                                <ErrorMessage name={`familydetails[${index}].memberDob`} component="div" className="text-error" />
                                                                            </jnb.InputGroup>
                                                                        </td>
                                                                        <td>
                                                                            <jnb.InputGroup className="">
                                                                                <Field type="text" autoComplete="off" maxLength="12" className="form-control" name={`familydetails[${index}].memberUid`}
                                                                                    onKeyPress={(e) => handleKeyAlphaNumeric(e)} disabled={showData?.renewal === true}
                                                                                    title="Enter your Family member Aadhar No(మీ కుటుంబ సభ్యుని ఆధార్ సంఖ్యను నమోదు చేయండి)"
                                                                                />
                                                                                <ErrorMessage name={`familydetails[${index}].memberUid`} component="div" className="text-error" /></jnb.InputGroup> </td>
                                                                        <td>
                                                                            <jnb.InputGroup className="form-control" title="select your Family member He/She Nominee(మీ కుటుంబ సభ్యుని అతను/ ఆమె నామినీ ఎంచుకోండి )">
                                                                                <Field type="radio" autoComplete="off" name={`familydetails[${index}].isNomine`} value="Y" disabled={showData?.renewal === true} /> &nbsp;Yes &nbsp;
                                                                                <Field type="radio" autoComplete="off" name={`familydetails[${index}].isNomine`} value="N" disabled={showData?.renewal === true}
                                                                                    onChange={() => {
                                                                                        Formik.setFieldValue(`familydetails[${index}].nominePer`, "")
                                                                                    }}
                                                                                />&nbsp;No &nbsp;
                                                                            </jnb.InputGroup>
                                                                            <ErrorMessage name={`familydetails[${index}].isNomine`} component="div" className="text-error" />
                                                                        </td>
                                                                        <td>
                                                                            {Formik?.values?.familydetails[index].isNomine === "Y" ? <React.Fragment>
                                                                                <jnb.InputGroup className="">
                                                                                    <Field as="select" className="form-control" autoComplete="off" disabled={showData?.renewal === true}
                                                                                        title="Percentage distribution of  Amount from a scheme 
                                                                                      (పథకం ద్వారా మంజూరైన  శాతం ఎంచుకోండి)"
                                                                                        // onInput={(e)=>{DeleteSelectPer(e,experienceDetails)}}
                                                                                        name={`familydetails[${index}].nominePer`}>
                                                                                        <option value="">--select--</option>
                                                                                        {perList.map((multiple, index) => (
                                                                                            <option key={index}>{multiple}</option>
                                                                                        ))}

                                                                                    </Field>
                                                                                    <ErrorMessage name={`familydetails[${index}].nominePer`} component="div" className="text-error" /></jnb.InputGroup>
                                                                            </React.Fragment> : ""}
                                                                        </td>
                                                                        <td>
                                                                            {index === 0 ? (
                                                                                <>
                                                                                    <button title="Add more family members
                                                                                (మరిన్ని కుటుంబ సభ్యులను జోడించడానికి)"
                                                                                        type="button" className="button-titile btn btn-sm btn-success" onClick={() => formikFieldArray.push({
                                                                                            relation: "",
                                                                                            memberName: "",
                                                                                            memberDob: "",
                                                                                            memberUid: "",
                                                                                            isNomine: "",
                                                                                            nominePer: ""
                                                                                        })} disabled={showData?.renewal === true} > <VscDiffAdded style={{ fontSize: "20px" }}></VscDiffAdded>
                                                                                    </button>
                                                                                </>) : ("")}
                                                                            {index !== 0 ? (
                                                                                <>
                                                                                    <button type="button" className="button-titile btn btn-sm btn-danger"
                                                                                        disabled={showData?.renewal === true}
                                                                                        onClick={() => formikFieldArray.remove(index)}><BiTrash style={{ fontSize: "20px" }}></BiTrash></button>
                                                                                </>) : ("")}
                                                                            {/* <ErrorMessage name="familydetails" component="div" className="text-error" /> */}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            });
                                                        }}
                                                    </FieldArray>
                                                </tbody>
                                            </table>
                                        </div>
                                    </jnb.Row>
                                    <div className="jumbotro mt20 form-card-jnb border my-3 mb-4">
                                        <jnb.Row className="px-3 py-2">
                                            <div className="inner-herbpage-service-title-sub">
                                                <h1>Bank Details(బ్యాంక్ వివరాలు)</h1>
                                            </div>
                                            <div className="form-card-jnb" >
                                                <jnb.Row className="pt-2">
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                                        <jnb.InputGroup className="">
                                                            <label className='d-block'>IFSC Code(ఐఎఫ్‌ఎస్‌సి కోడ్)</label>
                                                            <Field type="text" id="ifscCode" name="ifscCode" className="form-control w-100 mt-4" autoComplete="off"
                                                                // onBlur={(e) => { getBanksFunction(e) }}
                                                                // onChange={() => { clrBankName(); clrsubBranchName(); }}
                                                                title="Enter your IFSC Code(మీ ఐఎఫ్‌ఎస్‌సి కోడ్ నమోదు చేయండి)"
                                                                maxLength='11'
                                                                onKeyPress={(e) => handleKeyAlphaNumeric(e)} disabled={showData?.renewal === true}
                                                                onChange={(e) => {

                                                                    const ifsc_code = e?.target?.value?.toUpperCase();
                                                                    e.target.value = ifsc_code;
                                                                    if (e.target.value.length === 11) {
                                                                        getBanksFunction(ifsc_code);
                                                                    }
                                                                    else {
                                                                        clrBankName(); clrsubBranchName();
                                                                    }
                                                                }}
                                                            />
                                                            <ErrorMessage name="ifscCode" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                                        <jnb.InputGroup className="">
                                                            <label className='d-block'>Bank Name(బ్యాంకు పేరు)</label>
                                                            <Field type="text" name="bankName" className="form-control w-100 mt-4" placeholder="XXXXXXXX" autoComplete="off"
                                                                onKeyPress={(e) => handleKeyPressAlphabets(e)} disabled />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                                        <jnb.InputGroup className="">
                                                            <label className='d-block'>Branch Name(శాఖ పేరు)</label>
                                                            <Field type="text" name="branchName" className="form-control w-100 mt-4" placeholder="XXXXXXXX" autoComplete="off"
                                                                onKeyPress={(e) => handleKeyPressAlphabets(e)} disabled />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                                        <jnb.InputGroup className="">
                                                            <label className='d-block'> Bank account number(బ్యాంక్ ఖాతా సంఖ్య)</label>
                                                            <div style={{ position: "relative", width: "100%" }}>
                                                                <Field type={showPassword ? "text" : "password"} id="bankAccountNo"
                                                                    autoComplete="new-password" // ⬅️ Important
                                                                    className="form-control w-100 mt-1" name="bankAccountNo"
                                                                    onKeyPress={(e) => handleKeyPressNumeric(e)} maxLength='15' disabled={showData?.renewal === true}
                                                                    title="Enter your Bank account number(మీ బ్యాంక్ ఖాతా సంఖ్య నమోదు చేయండి)" />
                                                                <span
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "10px",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        cursor: "pointer",
                                                                        color: "#666",
                                                                    }}
                                                                >
                                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                                </span>
                                                            </div>
                                                            <ErrorMessage name="bankAccountNo" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                                        <jnb.InputGroup className="">
                                                            <label className='d-block'> RE-Enter Bank Account Number(బ్యాంక్ ఖాతా సంఖ్య మళ్లీ నమోదు చేయండి):</label>
                                                            <Field type="text " id="rbankAccountNo" className="form-control w-100 mt-1" name="rbankAccountNo" autoComplete="off"
                                                                onKeyPress={(e) => handleKeyPressNumeric(e)} maxLength='15' disabled={showData?.renewal === true}
                                                                title="RE-Enter Bank Account Number(మీ బ్యాంక్ ఖాతా సంఖ్య మళ్లీ నమోదు చేయండి)" />
                                                            <ErrorMessage name="rbankAccountNo" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                                        <jnb.InputGroup className="">
                                                            <label className='d-block'>Name in Bank(బ్యాంకులో పేరు):</label>
                                                            <Field
                                                                type="text"
                                                                id="nameInBank"
                                                                className="form-control w-100 mt-4"
                                                                name="nameInBank"
                                                                autoComplete="off" disabled={showData?.renewal === true}
                                                                maxLength='40'
                                                                onKeyPress={(e) => handleKeyPressAlphabets(e)} onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                                title="Enter Your Name as per Bank
                                                                 (బ్యాంకులో నమోదైన మీ పేరు)"
                                                            />
                                                            <ErrorMessage name="nameInBank" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                                        <jnb.InputGroup className="">
                                                            <label className='d-block w-100 mb-1'>Bank Passbook(1st page)(బ్యాంక్ పాస్‌బుక్ (మొదటి పేజీ):</label>
                                                            <input
                                                                type="File"
                                                                className="form-control"
                                                                name="bankPhotoDesc" disabled={showData?.renewal === true}
                                                                autoComplete="off"
                                                                onChange={(e) => {
                                                                    let fileVal = Formik?.values?.aadhaarNo;
                                                                    let filename = fileVal + "_bankPhotoDesc"
                                                                    if (fileVal) {
                                                                        EmpanelImageBucket(e, Formik, "bankPhotoDesc", filename)
                                                                    }
                                                                    else {
                                                                        Sweetalert("Please Enter Your Aadhaar", "warning")
                                                                        e.target.value = ""
                                                                    }
                                                                }}
                                                                title="Upload the copy of passbook 1st page 
                                                                (బ్యాంక్ పాస్‌బుక్ మొదటి పేజీ కాపీ అప్లోడ్ చేయండి)"
                                                            />
                                                            {Formik?.values?.bankPhotoDesc !== "" && (
                                                                <jnb.Button
                                                                    type="button"
                                                                    className="btn btn-primary ms-2 p-2 pt-1"
                                                                    onClick={() => {
                                                                        ViewImage(Formik?.values?.bankPhotoDesc);
                                                                        // handleView(Formik?.values?.bankPhotoDesc)
                                                                    }}
                                                                >
                                                                    <BsEye></BsEye>
                                                                </jnb.Button>
                                                            )}
                                                            {/* <Field type="hidden" name="bankPhotoDesc" /> */}

                                                            {/* <button type="button" className='btn btn-primary p-2 pt-1' onClick={() => {  ViewBucketImage({url:"Boc/e_1704967795575_944802610110_bankPhoto.pdf",value:true}) }}><BsEye></BsEye></button>  */}
                                                            <ErrorMessage name="bankPhotoDesc" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                </jnb.Row>
                                            </div>
                                        </jnb.Row>
                                    </div>
                                    <div className="inner-herbpage-service-title-sub mb-3">
                                        <h1>Address for Communication(చిరునామా)  </h1>
                                    </div>
                                    <div className="form-card-jnb border mb-3 " >
                                        <jnb.Row className="pt-0 px-2">
                                            <div className="inner-herbpage-service-title-sub mb-2">
                                                <h1 style={{ fontSize: "18px" }}>Present Address(ప్రస్తుత చిరునామా)</h1>
                                            </div>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label className=' w-100 mb-1'>District(జిల్లా)</label>
                                                    <Field as="select" name="presentDistrictCode" className="form-control w-100 nb-1" autoComplete="off"
                                                        onChange={(e) => {
                                                            const distCode = e.target.value;
                                                            Formik.setFieldValue('presentMadalCode', '');
                                                            Formik.setFieldValue('presentVillageCode', '');
                                                            setPresentalManList([]);
                                                            setPresentVillList([]);
                                                            if (distCode === "") {
                                                                setPresentDistCode('');
                                                            } else {
                                                                getPresentMandalFunction(distCode);
                                                            }
                                                        }}
                                                        title="select your Present District(మీ ప్రస్తుత జిల్లా ఎంచుకోండి)"
                                                    >
                                                        <option value="">--Select--</option>
                                                        {showDist !== undefined && showDist.map((ds, i) => {
                                                            return (<option key={i} value={ds.districtId}>{ds.distName}</option>);
                                                        })}
                                                    </Field>
                                                    <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                    <ErrorMessage name="presentDistrictCode" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label className=' w-100 nb-1'>Mandal(మండలం) </label>
                                                    <Field as="select" name="presentMadalCode" className="form-control w-100 mt-1" autoComplete="off"
                                                        onChange={(e) => {
                                                            const mandalCode = e.target.value;
                                                            if (mandalCode === "") {
                                                                setPresentVillList([]);
                                                                Formik.setFieldValue('presentVillageCode', '');
                                                            } else {
                                                                getPresentVillageDataFunction(e);
                                                            }
                                                        }}
                                                        title="select your Present Mandal(మీ ప్రస్తుత మండలం ఎంచుకోండి)"
                                                    >
                                                        <option value="">--Select--</option>
                                                        {showPresentalManList !== undefined && showPresentalManList.map((ms, i) => {
                                                            return (<option key={i} value={ms.mandalCode}>{ms.mandalName}</option>);
                                                        })}
                                                    </Field>
                                                    <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                    <ErrorMessage name="presentMadalCode" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label>Village(గ్రామం)</label>
                                                    <Field as="select" name="presentVillageCode" className="form-control w-100 mt-1" autoComplete="off"
                                                        title="select your Present Village(మీ ప్రస్తుత గ్రామం ఎంచుకోండి)"
                                                        onChange={() => {
                                                            Formik.setFieldValue('presentOtherVillageName', "")
                                                        }}
                                                    >
                                                        <option value="">--Select--</option>
                                                        {showPresentVillList !== undefined && showPresentVillList.map((vs, i) => {
                                                            return (<option key={i} value={vs.village_code}>{vs.village_name}</option>);
                                                        })}
                                                        <option value={0}>Other(ఇతర)</option>
                                                    </Field>
                                                    <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                    <ErrorMessage name="presentVillageCode" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            {Formik.values.presentVillageCode == 0 && (
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                    <jnb.InputGroup className="">
                                                        <label className=' w-100 nb-1'>Other Village Name (ఇతర గ్రామం)</label>
                                                        <Field
                                                            type="text"
                                                            name="presentOtherVillageName"
                                                            className="form-control w-100"
                                                            placeholder="Enter village name"
                                                            onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                                            maxLength='30'
                                                            title="Enter other village name(ఇతర గ్రామం పేరు నమోదు చేయండి)"
                                                            autoComplete="off"
                                                        />
                                                        <ErrorMessage name="presentOtherVillageName" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                            )}
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label>Pincode (పిన్‌కోడ్)</label>
                                                    <Field type="text" className="form-control w-100 mt-1" name="presentPincode" maxLength="6" autoComplete="off"
                                                        title="Enter your Present Pincode(మీ ప్రస్తుత పిన్‌కోడ్ నమోదు చేయండి)"
                                                    />
                                                    <ErrorMessage name="presentPincode" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label>Door No(ఇంటి నంబర్).</label>
                                                    <Field type="text" className="form-control w-100 mt-4" name="presentDoorNo" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                        maxLength="15"
                                                        onKeyPress={(e) => allowCharsAndNumericMaxSpaces(e)}
                                                        title="Enter your Present Door No(మీ ప్రస్తుత ఇంటి నంబర్ నమోదు చేయండి)"
                                                        autoComplete="off"
                                                    />
                                                    <ErrorMessage name="presentDoorNo" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label>Address(చిరునామా)</label>
                                                    <Field as="textarea" id="presentAddress" name="presentAddress" rows={1} className="form-control w-100 my-1 mt-4" cols={50} onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                        maxLength="100" autoComplete="off"
                                                        title="Enter your Present Address(మీ ప్రస్తుత చిరునామా నమోదు చేయండి)"
                                                    ></Field>
                                                    <ErrorMessage name="presentAddress" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label> Division/Ward Number(డివిజన్/వార్డ్ నంబర్)</label>
                                                    <Field type="text" id="presentDivision" name="presentDivision" className="form-control w-100 my-1 " onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                        maxLength="20" autoComplete="off"
                                                        title="Enter your Present Division/Ward Number(మీ ప్రస్తుత డివిజన్/వార్డ్ నంబర్ నమోదు చేయండి)"
                                                    ></Field>
                                                    <ErrorMessage name="presentDivision" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label>Landmark/Locality(ల్యాండ్‌మార్క్/ప్రాంతం)</label>
                                                    <Field as="textarea" id="presentLandMark" name="presentLandMark" rows={1} maxLength="100" className="form-control w-100 my-1" cols={50} onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                        title="Enter your Present Landmark/Locality(మీ ప్రస్తుత ల్యాండ్‌మార్క్/ప్రాంతం నమోదు చేయండి)" autoComplete="off"
                                                    ></Field>
                                                    <ErrorMessage name="presentLandMark" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label>town/city(నగరం/పట్టణం)</label>
                                                    <Field type="text" id="presentCity" name="presentCity" className="form-control w-100 my-1" maxLength="20" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                        title="Enter your Present town/city(మీ ప్రస్తుత నగరం/పట్టణం నమోదు చేయండి)" autoComplete="off"
                                                    ></Field>
                                                    <ErrorMessage name="presentCity" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                        </jnb.Row>
                                        <jnb.Row className="pt-0 px-2">
                                            <div className="inner-herbpage-service-title-sub mb-2">
                                                <h1 style={{ fontSize: "18px" }}>Permanent Address(శాశ్వత చిరునామా)  </h1>
                                            </div>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={6} xxl={6}>
                                                <jnb.InputGroup className="mb-3" >
                                                    <label>Is your Present address same as Permanent address(మీ ప్రస్తుత చిరునామా మరియు శాశ్వత చిరునామా ఒకటేనా)?</label>
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                                <jnb.InputGroup className="" title="select your option(మీ ఎంపికను ఎంచుకోండి)">
                                                    <Field type="radio" value="Y" name="isPermanent" autoComplete="off" disabled={showData?.renewal === true} />&emsp;Yes(అవును)&emsp;&emsp;
                                                    <Field type="radio" value="N" name="isPermanent" autoComplete="off" disabled={showData?.renewal === true} onChange={() => {
                                                        Formik.setFieldValue('permanentDistrictCode', "")
                                                        Formik.setFieldValue('permanentMadalCode', "")
                                                        Formik.setFieldValue('permanentVillageCode', "")
                                                        Formik.setFieldValue('permanentPincode', "")
                                                        Formik.setFieldValue('permanentDoorNo', "")
                                                        Formik.setFieldValue('permanentAddress', "")
                                                        Formik.setFieldValue('permanentDivision', "")
                                                        Formik.setFieldValue('permanentCity', "")
                                                        Formik.setFieldValue('permanentLandMark', "")
                                                        Formik.setFieldValue('permanentOtherVillageName', "")
                                                    }} />&emsp;No(కాదు)
                                                    <ErrorMessage name="isPermanent" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            {Formik?.values?.isPermanent === "N" && (
                                                <jnb.Row>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                        <jnb.InputGroup className="">
                                                            <label className=' w-100 mb-1'>District(జిల్లా)</label>
                                                            <Field as="select" name="permanentDistrictCode" className="form-control w-100 nb-1" autoComplete="off"
                                                                disabled={showData?.renewal === true}
                                                                onChange={(e) => {
                                                                    const distCode = e.target.value;
                                                                    Formik.setFieldValue('permanentMadalCode', '');
                                                                    Formik.setFieldValue('permanentVillageCode', '');
                                                                    setPermntManList([]);
                                                                    setPermntVillList([]);
                                                                    if (distCode === "") {
                                                                        setPermntDistCode('');
                                                                    } else {
                                                                        getPermanentMandalFunction(distCode);
                                                                    }
                                                                }}
                                                                title="select your Permanent District(మీ శాశ్వత జిల్లా ఎంచుకోండి)"
                                                            >
                                                                <option value="">--Select--</option>
                                                                {showDist !== undefined && showDist.map((ds, i) => {
                                                                    return (<option key={i} value={ds.districtId}>{ds.distName}</option>);
                                                                })}
                                                            </Field>
                                                            <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                            <ErrorMessage name="permanentDistrictCode" component="div" className="text-error" />

                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                        <jnb.InputGroup className="">
                                                            <label className=' w-100 nb-1'>Mandal(మండలం) </label>
                                                            <Field as="select" name="permanentMadalCode" className="form-control w-100 mt-1" autoComplete="off"
                                                                onChange={(e) => {
                                                                    const mandalcode = e.target.value;
                                                                    if (mandalcode === "") {
                                                                        setPermntVillList([]);
                                                                        Formik.setFieldValue('permanentVillageCode', '');
                                                                    } else {
                                                                        getPermntVillageDataFunction(e);
                                                                    }
                                                                }} disabled={showData?.renewal === true}
                                                                title="select your Permanent Mandal(మీ శాశ్వత మండలం ఎంచుకోండి)"
                                                            >
                                                                <option value="">--Select--</option>
                                                                {showPermntManList !== undefined && showPermntManList.map((ms, i) => {
                                                                    return (<option key={i} value={ms.mandalCode}>{ms.mandalName}</option>);
                                                                })}
                                                            </Field>
                                                            <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                            <ErrorMessage name="permanentMadalCode" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                        <jnb.InputGroup className="">
                                                            <label>Village(గ్రామం)</label>
                                                            <Field as="select" name="permanentVillageCode" className="form-control w-100 mt-1" autoComplete="off"
                                                                title="select your Permanent Village(మీ శాశ్వత గ్రామం ఎంచుకోండి)" disabled={showData?.renewal === true}
                                                            >
                                                                <option value="">--Select--</option>
                                                                {showPermntVillList !== undefined && showPermntVillList.map((vs, i) => {
                                                                    return (<option key={i} value={vs.village_code}>{vs.village_name}</option>);
                                                                })}
                                                                <option value={0}>Other(ఇతర)</option>
                                                            </Field>
                                                            <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                            <ErrorMessage name="permanentVillageCode" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    {Formik.values.permanentVillageCode == 0 && (
                                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                            <jnb.InputGroup className="">
                                                                <label className=' w-100 nb-1'> Other Village Name(ఇతర గ్రామం)</label>
                                                                <Field
                                                                    type="text"
                                                                    name="permanentOtherVillageName"
                                                                    className="form-control w-100"
                                                                    placeholder="Enter village name"
                                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                                                    maxLength='30'
                                                                    title="Enter other village name (ఇతర గ్రామం పేరు నమోదు చేయండి)"
                                                                    autoComplete="off" disabled={showData?.renewal === true}
                                                                />
                                                                <ErrorMessage name="permanentOtherVillageName" component="div" className="text-error" />
                                                            </jnb.InputGroup>
                                                        </jnb.Col>
                                                    )}
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                        <jnb.InputGroup className="">
                                                            <label>Pincode (పిన్‌కోడ్)</label>
                                                            <Field type="text" className="form-control w-100 mt-1" name="permanentPincode" maxLength="6"
                                                                onKeyPress={(e) => handleKeyPressNumeric(e)} disabled={showData?.renewal === true}
                                                                title="Enter your Permanent Pincode(మీ శాశ్వత పిన్‌కోడ్ నమోదు చేయండి)" autoComplete="off"
                                                            />
                                                            <ErrorMessage name="permanentPincode" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                        <jnb.InputGroup className="">
                                                            <label>Door No.(ఇంటి నంబర్)</label>
                                                            <Field type="text" className="form-control w-100 mt-4" name="permanentDoorNo" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                                maxLength="15" onKeyPress={(e) => allowCharsAndNumericMaxSpaces(e)} disabled={showData?.renewal === true}
                                                                title="Enter your Permanent Door No(మీ శాశ్వత ఇంటి నంబర్ నమోదు చేయండి)" autoComplete="off"
                                                            />
                                                            <ErrorMessage name="permanentDoorNo" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>

                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                        <jnb.InputGroup className="">
                                                            <label>Address(చిరునామా)</label>
                                                            <Field as="textarea" name="permanentAddress" rows={1} className="form-control w-100 my-1 mt-4" cols={50} maxLength="100" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                                title="Enter your Permanent Address(మీ శాశ్వత చిరునామా నమోదు చేయండి)" autoComplete="off" disabled={showData?.renewal === true}
                                                            ></Field>
                                                            <ErrorMessage name="permanentAddress" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                        <jnb.InputGroup className="">
                                                            <label> Division/Ward Number(డివిజన్/వార్డ్ నంబర్)</label>
                                                            <Field type="text" id="permanentDivision" name="permanentDivision" className="form-control w-100 my-1" maxLength="20" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                                title="Enter your Permanent Division/Ward Number(మీ శాశ్వత డివిజన్/వార్డ్ నంబర్ నమోదు చేయండి)" autoComplete="off" disabled={showData?.renewal === true}
                                                            ></Field>
                                                            <ErrorMessage name="permanentDivision" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                        <jnb.InputGroup className="">
                                                            <label>Landmark/Locality(ల్యాండ్‌మార్క్/ప్రాంతం)</label>
                                                            <Field as="textarea" id="permanentLandMark" name="permanentLandMark" rows={1} className="form-control w-100 my-1" cols={50} maxLength="100" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                                title="Enter your Permanent Landmark/Locality(మీ శాశ్వత ల్యాండ్‌మార్క్/ప్రాంతం నమోదు చేయండి)" autoComplete="off" disabled={showData?.renewal === true}
                                                            ></Field>
                                                            <ErrorMessage name="permanentLandMark" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                        <jnb.InputGroup className="">
                                                            <label>town/city(నగరం/పట్టణం)</label>
                                                            <Field type="text" id="permanentCity" name="permanentCity" className="form-control w-100 my-1" maxLength="20" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                                title="Enter your Permanent town/city(మీ శాశ్వత నగరం/పట్టణం నమోదు చేయండి)" autoComplete="off" disabled={showData?.renewal === true}
                                                            ></Field>
                                                            <ErrorMessage name="permanentCity" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                </jnb.Row>)}
                                        </jnb.Row>
                                    </div>
                                    <jnb.Row className="pt-0">
                                        <div className="inner-herbpage-service-title-sub mb-2">
                                            <h1> Other Details (ఇతర వివరాలు)</h1>
                                        </div>
                                        <label className='mb-2'>Is he/she is an MGNREGS worker(అతను/ఆమె మహాత్మా గాంధీ జాతీయ గ్రామీణ ఉపాధి కార్మికులా)?</label>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="form-control mb-3 mt-4" title="select your option(మీ ఎంపికను ఎంచుకోండి)" >
                                                <Field type="radio" name="isNregs" value="Y" autoComplete="off" disabled={showData?.renewal === true} /> &nbsp;Yes &nbsp;
                                                <Field type="radio" name="isNregs" value="N" autoComplete="off" disabled={showData?.renewal === true}
                                                    onChange={() => {
                                                        Formik.setFieldValue('jobCardNo', "")
                                                        Formik.setFieldValue('wordDaysCopyDesc', "")
                                                    }}
                                                />&nbsp;No &nbsp;
                                            </jnb.InputGroup>
                                            <ErrorMessage name="isNregs" component="div" className="text-error" />
                                        </jnb.Col>
                                        {Formik?.values?.isNregs === "Y" ? <React.Fragment>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                <jnb.InputGroup className="">
                                                    <label>Job card Number(జాబ్ కార్డ్ నంబర్)</label>
                                                    <Field type="text" className="form-control w-100 mt-4" name="jobCardNo"
                                                        title="Enter your Job card Number(మీ జాబ్ కార్డ్ నంబర్ నమోదు చేయండి)"
                                                        maxLength='12' autoComplete="off" disabled={showData?.renewal === true} />
                                                    <ErrorMessage name="jobCardNo" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                <jnb.InputGroup className="">
                                                    <label className='d-block w-100 mb-1'>No.of work days copy(పని రోజుల ప్రతులు)</label>
                                                    <input type="file" className="form-control " name="wordDaysCopyDesc" autoComplete="off"
                                                        onChange={(e) => {
                                                            let fileVal = Formik?.values?.aadhaarNo;
                                                            let filename = fileVal + "_wordDaysCopyDesc"
                                                            if (fileVal) {
                                                                ImageBucket(e, Formik, "wordDaysCopyDesc", filename)
                                                            }
                                                            else {
                                                                Sweetalert("Please Enter Your Aadhaar", "warning")
                                                                e.target.value = ""
                                                            }
                                                        }} disabled={showData?.renewal === true}
                                                        title="Upload No.of work days copy (పని రోజుల ప్రతులు అప్లోడ్ చేయండి)"
                                                    />
                                                    {Formik?.values?.wordDaysCopyDesc !== "" && (
                                                        <jnb.Button
                                                            type="button"
                                                            className="btn btn-primary ms-2 p-2 pt-1"
                                                            onClick={() => {
                                                                ViewImage(Formik?.values?.wordDaysCopyDesc);
                                                                // handleView(Formik?.values?.wordDaysCopyDesc)
                                                            }}
                                                        >
                                                            <BsEye></BsEye>
                                                        </jnb.Button>
                                                    )}
                                                    {/* <Field type="hidden" name="wordDaysCopyDesc" /> */}
                                                    <ErrorMessage name="wordDaysCopyDesc" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                        </React.Fragment> : ""}
                                    </jnb.Row>
                                    <jnb.Row className="pt-0">
                                        <div className="inner-herbpage-service-title-sub mb-2">
                                            <h1> Trade Union(కార్మిక సంఘం)</h1>
                                        </div>
                                        <label className='mb-3'>Is the worker a member of any trade union (కార్మికుడు/కార్మికురాలు ఏదైనా కార్మిక సంఘంలో సభ్యుడా/సభ్యురాలా)?</label>

                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="form-control mb-3 mt-4" title="select your option(మీ ఎంపికను ఎంచుకోండి)">

                                                <Field type="radio" name="isUnionMember" value="Y" autoComplete="off" disabled={showData?.renewal === true} /> &nbsp;Yes &nbsp;
                                                <Field type="radio" name="isUnionMember" value="N" autoComplete="off" disabled={showData?.renewal === true}
                                                    onChange={() => {
                                                        Formik.setFieldValue('unionName', "")
                                                        Formik.setFieldValue('regNo', "")
                                                    }}
                                                />&nbsp;No &nbsp;
                                            </jnb.InputGroup>
                                            <ErrorMessage name="isUnionMember" component="div" className="text-error" />
                                        </jnb.Col>

                                        {Formik?.values?.isUnionMember === "Y" ? <React.Fragment>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                <jnb.InputGroup className="">
                                                    <label>Union Name(యూనియన్ పేరు)</label>
                                                    <Field type="text" className="form-control w-100 mt-3" name="unionName"
                                                        onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                        maxLength='30' disabled={showData?.renewal === true}
                                                        title="Enter your Union Name(మీ యూనియన్ పేరు నమోదు చేయండి)" autoComplete="off"
                                                    />
                                                    <ErrorMessage name="unionName" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                <jnb.InputGroup className="">
                                                    <label>Registration No(నమోదు సంఖ్య).</label>
                                                    <Field type="text" className="form-control w-100 mt-3" name="regNo"
                                                        maxLength='12' autoComplete="off" disabled={showData?.renewal === true}
                                                        title="Enter your Registration No(మీ నమోదు సంఖ్య నమోదు చేయండి)"
                                                    />
                                                    <ErrorMessage name="regNo" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                        </React.Fragment> : ""}
                                    </jnb.Row>
                                    <jnb.Row className="pt-0">
                                        <div className="inner-herbpage-service-title-sub mb-3">
                                            <h1>Work Place Details(ప్రస్తుత పని స్థలం వివరాలు)</h1>
                                        </div>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
                                            <jnb.InputGroup className="">
                                                <label> Name of the Employer(యాజమాని పేరు)</label>
                                                <Field type="text" className="form-control w-100 mt-1" name="empName" autoComplete="off"
                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)} onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                    maxLength='40'
                                                    title="Enter Employer Name (మీ యాజమాని పేరు నమోదు చేయండి)" disabled={showData?.renewal === true}
                                                />
                                                <ErrorMessage name="empName" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="">
                                                <label>Name of the Construction Organisation(నిర్మాణ సంస్థ పేరు)</label>
                                                <Field type="text" className="form-control w-100 mt-1" name="presentOfficeName" autoComplete="off"
                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)} onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                    maxLength='50'
                                                    title="Enter Construction Organisation Name (మీ నిర్మాణ సంస్థ పేరు నమోదు చేయండి)" disabled={showData?.renewal === true}
                                                />
                                                <ErrorMessage name="presentOfficeName" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="">
                                                <label>Trade of work(వృత్తి / పని)</label>
                                                <Field as="select" className="form-control w-100 mt-4" name="typeOfWork"
                                                    title="select Trade of work(మీ వృత్తి/పని ఎంచుకోండి)" autoComplete="off" disabled={showData?.renewal === true}
                                                >
                                                    <option value="">---select---</option>
                                                    <option value="Tiles">Tiles</option>
                                                    <option value="Mason">Mason</option>
                                                    <option value="Electrician">Electrician</option>
                                                    <option value="Bar Bender">Bar Bender</option>
                                                    <option value="Interior Decoration Worker">Interior Decoration Worker</option>
                                                    <option value="Centering Worker">Centering Worker</option>
                                                    <option value="Carpenter">Carpenter</option>
                                                    <option value="Earth Worker">Earth Worker</option>
                                                    <option value="Painter or Varnisher">Painter or Varnisher</option>
                                                    <option value="Helper">Helper</option>
                                                    <option value="Fitter">Fitter</option>
                                                    <option value="Well Sinker">Well Sinker</option>
                                                    <option value="Welder">Welder</option>
                                                    <option value="Brick Klin Worker">Brick Klin Worker</option>
                                                    <option value="Worker engaged in anti-sea erosion worker">Worker engaged in anti-sea erosion work</option>
                                                    <option value="Worker engaged in processing lime">Worker engaged in processing lime</option>
                                                    <option value="Kalasis or sarang engaged in heavy engineering construction">Kalasis or Sarang (Heavy Engineering Construction)</option>
                                                    <option value="Quarry Worker">Quarry Worker</option>
                                                    <option value="False ceiling Worker">False Ceiling Worker</option>
                                                    <option value="Wooden or Stone Packer">Wooden or Stone Packer</option>
                                                    <option value="Municipal Drainage Worker">Municipal Drainage Worker</option>
                                                    <option value="Rigger">Rigger</option>
                                                    <option value="Marble or Kadapa Stone Worker">Marble or Kadapa Stone Worker</option>
                                                    <option value="Mixer Driver or Roller Driver">Mixer Driver or Roller Driver</option>
                                                    <option value="Plumber or Sanitary Worker">Plumber or Sanitary Worker</option>
                                                    <option value="Stone Cutter or Stone Breaker or Stone Crusher">Stone Cutter / Breaker / Crusher</option>
                                                    <option value="Spary man or Mixer (Road Surfing)">Spray Man or Mixer (Road Surfacing)</option>
                                                    <option value="Mosaic Worker or Polishing Worker">Mosaic Worker or Polishing Worker</option>
                                                    <option value="Mixer or Pump Operator">Mixer or Pump Operator</option>
                                                    <option value="Watch Man or Security at construction work">Watchman or Construction Site Security</option>
                                                    <option value="Thatcher or Blacksmith or Sawer or Caulker">Thatcher / Blacksmith / Sawer / Caulker</option>
                                                    <option value="Tunnel Worker or Rock worker">Tunnel Worker or Rock Worker</option>
                                                    <option value="Solar Fencing Worker">Solar Fencing Worker</option>
                                                    <option value="Mud Mixing Worker">Mud Mixing Worker</option>
                                                    <option value="Road Laying">Road Laying</option>
                                                    <option value="Construction Site Security">Construction Site Security</option>
                                                    <option value="Supervisors in Construction Work">Supervisor in Construction Work</option>
                                                    <option value="pump Operator">Pump Operator</option>
                                                    <option value="Hammer/man">Hammerman</option>
                                                    <option value="Sawer">Sawer</option>
                                                    <option value="Roller Driver">Roller Driver</option>
                                                    <option value="Tunnel Worker">Tunnel Worker</option>
                                                    <option value="Road Worker">Road Worker</option>
                                                    <option value="Brick Maker">Brick Maker</option>
                                                    <option value="Tile Roofing Worker">Tile Roofing Worker</option>
                                                    <option value="Landscaping Worker">Landscaping Worker</option>
                                                    <option value="Electricity Substation Worker">Electricity Substation Worker</option>
                                                    <option value="Head Mazdoor">Head Mazdoor</option>
                                                    <option value="Road Surfing">Road Surfacing</option>
                                                    <option value="Caulker">Caulker</option>
                                                    <option value="Pre-fabricating Structural Worker">Pre-fabricating Structural Worker</option>
                                                    <option value="Lifts,Escalators Installation workers">Lifts / Escalator Installation Workers</option>
                                                    <option value="Glass Worker">Glass Worker</option>
                                                    <option value="Cooli">Coolie</option>
                                                    <option value="Mason Cooli">Mason Coolie</option>
                                                    <option value="MNREG Cooli">MNREG Coolie</option>
                                                    <option value="Mechanic">Mechanic</option>
                                                </Field>
                                                <ErrorMessage name="typeOfWork" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <label>Do you need any training(మీకు శిక్షణ అవసరమా)?</label>
                                            <jnb.InputGroup className="form-control">
                                                <Field type="radio" name="workCapability" value="Y" autoComplete="off" disabled={showData?.renewal === true} /> &nbsp;Yes &nbsp;
                                                <Field type="radio" name="workCapability" value="N" autoComplete="off" disabled={showData?.renewal === true}
                                                />&nbsp;No &nbsp;
                                                {/* <Field as="select" className="form-control w-100 mt-4" name="workCapability"
                                             title="select Category of Worker(కార్మికుల వర్గీకరణ ఎంచుకోండి)">
                                                    <option value="">---select---</option>
                                                    <option value="1" title="అత్యుత్తమ నైపుణ్యంతో కూడిన పని నిపుణులు, స్వతంత్రంగా క్లిష్టమైన పనులు చేయగలుగుతారు">High Skilled(అత్యున్నత నైపుణ్యం)</option>
                                                    <option value="2" title="శిక్షణ పొందినవారు, కొంత అనుభవం ఉన్నవారు, స్వల్ప పర్యవేక్షణతో పని చేయగలుగుతారు">Skilled(నైపుణ్యం ఉన్నవారు)</option>
                                                    <option value="3" title="కొంత శిక్షణ లేదా అనుభవం ఉన్నవారు, క్లిష్టమైన పనులకు పర్యవేక్షణ అవసరం">Semi Skilled (పాషిక నైపుణ్యం లేని వారు)</option>
                                                    <option value="4" title="ప్రత్యేక శిక్షణ అవసరం లేకుండా సాధారణ శారీరక శ్రమ చేసే వారు">Un-Skilled(నైపుణ్యం లేని వారు)</option>
                                                </Field> */}
                                                <ErrorMessage name="workCapability" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-3">
                                                <label className=' w-100 mb-1'>Distric(జిల్లా)</label>
                                                <Field as="select" name="officeDistrictCode" className="form-control w-100 nb-1" autoComplete="off" disabled={showData?.renewal === true}

                                                    onChange={(e) => {
                                                        const distCode = e.target.value;
                                                        Formik.setFieldValue('officeMadalCode', '');
                                                        Formik.setFieldValue('officeVillageCode', '');
                                                        setOfficeManList([]);
                                                        setOfficeVillList([]);
                                                        if (distCode === "") {
                                                            setOfficeDistCode('');
                                                        } else {
                                                            getOfficeMandalFunction(distCode);
                                                        }
                                                    }}
                                                    title="select Work Place Distric (పని స్థలం జిల్లా ఎంచుకోండి)"
                                                >
                                                    <option value="">--Select--</option>
                                                    {showDist !== undefined && showDist.map((ds, i) => {
                                                        return (<option key={i} value={ds.districtId}>{ds.distName}</option>);
                                                    })}
                                                </Field>
                                                <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                <ErrorMessage name="officeDistrictCode" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-3">
                                                <label className=' w-100 nb-1'>Mandal(మండలం)</label>
                                                <Field as="select" name="officeMadalCode" className="form-control w-100" autoComplete="off" disabled={showData?.renewal === true}
                                                    onChange={(e) => {
                                                        const MandalCode = e.target.value;
                                                        if (MandalCode === "") {
                                                            setOfficeVillList([]);
                                                            Formik.setFieldValue('officeVillageCode', '');
                                                        } else {
                                                            getOfficeVillageDataFunction(e);
                                                        }
                                                    }}
                                                    title="select Work Place Mandal (పని స్థలం మండలం ఎంచుకోండి)"
                                                >
                                                    <option value="">--Select--</option>
                                                    {showOfficeManList !== undefined && showOfficeManList.map((ms, i) => {

                                                        return (<option key={i} value={ms.mandalCode}>{ms.mandalName}</option>);
                                                    })}
                                                </Field>
                                                <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                <ErrorMessage name="officeMadalCode" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-3">
                                                <label>Village(గ్రామం)</label>
                                                <Field as="select" name="officeVillageCode" className="form-control w-100 mt-1" autoComplete="off"
                                                    onChange={() => {
                                                        Formik.setFieldValue('officeOtherVillageName', "")
                                                    }} disabled={showData?.renewal === true}
                                                    title="select Work Place Village (పని స్థలం గ్రామం ఎంచుకోండి)"
                                                >
                                                    <option value="">--Select--</option>
                                                    {showOfficeVillList !== undefined && showOfficeVillList.map((vs, i) => {
                                                        return (<option key={i} value={vs.village_code}>{vs.village_name}</option>);
                                                    })}
                                                    <option value={0}>Other(ఇతర)</option>
                                                </Field>
                                                <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                <ErrorMessage name="officeVillageCode" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        {Formik.values.officeVillageCode == 0 && (
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label className=' w-100 nb-1'>Other Village Name (ఇతర గ్రామం)</label>
                                                    <Field
                                                        type="text"
                                                        name="officeOtherVillageName"
                                                        className="form-control w-100"
                                                        placeholder="Enter village name"
                                                        onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                                        maxLength='30'
                                                        title="Enter other village name(ఇతర గ్రామం పేరు నమోదు చేయండి)" disabled={showData?.renewal === true}
                                                        autoComplete="off"
                                                    />
                                                    <ErrorMessage name="officeOtherVillageName" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                        )}
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-3">
                                                <label>Pincode(పిన్ కోడ్)</label>
                                                <Field type="text" className="form-control w-100 mt-1" name="officePincode" maxLength="6"
                                                    onKeyPress={(e) => handleKeyPressNumeric(e)} disabled={showData?.renewal === true}
                                                    title="Enter work Place Pincode(పని స్థలం పిన్ కోడ్ నమోదు చేయండి )" autoComplete="off" />
                                                <ErrorMessage name="officePincode" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-3">
                                                <label>Door No(ఇంటి నంబర్).</label>
                                                <Field type="text" className="form-control w-100 mt-1" name="officeDoorNo" maxLength="15" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                    // onKeyPress={(e) => allowCharsAndNumericMaxSpaces(e)} 
                                                    title="Enter work Place Door No(పని స్థలం ఇంటి నంబర్ నమోదు చేయండి )" autoComplete="off" disabled={showData?.renewal === true} />
                                                <ErrorMessage name="officeDoorNo" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-3 mb-3">
                                                <label>Address(చిరునామా)</label>
                                                <Field as="textarea" id="officeAddress" name="officeAddress" rows={1} maxLength="100" className="form-control w-100 my-1" cols={50} onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                    title="Enter work Place Address(పని స్థలం చిరునామా నమోదు చేయండి )" autoComplete="off" disabled={showData?.renewal === true}></Field>
                                                <ErrorMessage name="officeAddress" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                    </jnb.Row>
                                </div>
                                <jnb.Row className="pt-0">
                                    <div className="inner-herbpage-service-title-sub mb-2">
                                        <h1> Migrant Worker(వలస కార్మికుడు)</h1>
                                    </div>
                                    <label className='mb-3'>Are you a migrant worker(మీరు వలస కార్మికుడా)?</label>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                        <jnb.InputGroup className="form-control mb-3 mt-4" title="select your option(మీ ఎంపికను ఎంచుకోండి)">
                                            <Field type="radio" name="isMigrant" value="Y" autoComplete="off" disabled={showData?.renewal === true} /> &nbsp;Yes &nbsp;
                                            <Field type="radio" name="isMigrant" value="N" autoComplete="off" disabled={showData?.renewal === true}
                                            //  onChange={() => { 
                                            //            Formik.setFieldValue('migrantDistrictCode',"")
                                            //            Formik.setFieldValue('migrantMadalCode',"")
                                            //             Formik.setFieldValue('migrantVillageCode',"")
                                            //            Formik.setFieldValue('migrantPincode',"")
                                            //         }} 
                                            />&nbsp;No &nbsp;
                                        </jnb.InputGroup>
                                        <ErrorMessage name="isMigrant" component="div" className="text-error" />
                                    </jnb.Col>
                                    {/* {Formik?.values?.isMigrant   === "Y" ? <React.Fragment>
                                             <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-3">
                                                <label className=' w-100 mb-1'>Distric(జిల్లా)</label>
                                                <Field as="select" name="migrantDistrictCode" className="form-control w-100 nb-1"
                                                    onChange={(e) => {
                                                        getmigrantMandalFunction(e)
                                                        //  ClearFunction('madalCode','');
                                                        //  ClearFunction('secretariat','');
                                                        //  ClearFunction('villageCode','')
                                                    }}
                                             title="select Work Place Distric (పని స్థలం జిల్లా ఎంచుకోండి)"
                                                >
                                                    <option value="">--Select--</option>
                                                    {showDist !== undefined && showDist.map((ds, i) => {
                                                        return (<option key={i} value={ds.districtId}>{ds.distName}</option>);
                                                    })}
                                                </Field>
                                                <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                <ErrorMessage name="migrantDistrictCode" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-3">
                                                <label className=' w-100 nb-1'>Mandal(మండలం)</label>
                                                <Field as="select" name="migrantMadalCode" className="form-control w-100"
                                                    onChange={(e) => { //getSecretrait(e);
                                                        getmigrantVillageDataFunction(e);
                                                        // ClearFunction('secretariat','');ClearFunction('villageCode','')
                                                    }}
                                             title="select Work Place Mandal (పని స్థలం మండలం ఎంచుకోండి)"
                                                >
                                                    <option value="">--Select--</option>
                                                    {showmigrantManList !== undefined && showmigrantManList.map((ms, i) => {

                                                        return (<option key={i} value={ms.mandalCode}>{ms.mandalName}</option>);
                                                    })}
                                                </Field>
                                                <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                <ErrorMessage name="migrantMadalCode" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-3">
                                                <label>Village(గ్రామం)</label>
                                                <Field as="select" name="migrantVillageCode" className="form-control w-100 mt-1"
                                                  onChange={() => { 
                                                           Formik.setFieldValue('migrantOtherVillageName',"")
                                                        }} 
                                             title="select Work Place Village (పని స్థలం గ్రామం ఎంచుకోండి)"
                                                >
                                                    <option value="">--Select--</option>
                                                    {showmigrantVillList !== undefined && showmigrantVillList.map((vs, i) => {
                                                        //console.log("office",showOfficeVillList)
                                                        return (<option key={i} value={vs.village_code}>{vs.village_name}</option>);
                                                    })}
                                        <option value="0">Other(ఇతర)</option>
                                                </Field>
                                                <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                <ErrorMessage name="migrantVillageCode" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                         {Formik.values.migrantVillageCode === "0" && (
  <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
    <label className=' w-100 nb-1'>Other Village Name (ఇతర గ్రామం)</label>
    <Field
      type="text"
      name="migrantOtherVillageName"
      className="form-control w-100"
      placeholder="Enter village name"
       onKeyPress={(e) => handleKeyPressAlphabets(e)}
        maxLength='30'
      title="Enter other village name(ఇతర గ్రామం పేరు నమోదు చేయండి)"
    />
    <ErrorMessage name="migrantOtherVillageName" component="div" className="text-error" />
 </jnb.InputGroup>
 </jnb.Col>
)}

                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-3">
                                                <label>Pincode(పిన్ కోడ్)</label>
                                                <Field type="text" className="form-control w-100 mt-1" name="migrantPincode" maxLength="6"
                                                    onKeyPress={(e) => handleKeyPressNumeric(e)} 
                                                    title="Enter work Place Pincode(పని స్థలం పిన్ కోడ్ నమోదు చేయండి )"/>
                                                <ErrorMessage name="migrantPincode" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        </React.Fragment> : ""} */}
                                </jnb.Row>
                                <jnb.Row className="pt-0">
                                    <div className="inner-herbpage-service-title-sub mb-2">
                                        <h1>Uploads(అప్‌లోడ్లు)</h1>
                                    </div>
                                    <div className="mb-2">
                                        <h6 className="text-danger"> NOTE:&emsp;
                                            {/* <a href="https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/OBMMS_UPLOADS/1749798217830_623299402750_selfAffidavitDesc.pdf" ></a> */}
                                            {/* <a href="https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/OBMMS_UPLOADS/1749800559146_623299402750_selfAffidavitDesc.pdf"></a> */}
                                            <a href="https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/OBMMS_UPLOADS/1749798217830_623299402750_selfAffidavitDesc.pdf"
                                                className="text-success" target="blank" >
                                                <b className="headlin text-success" title="Download and sign the self Declaration document from the above link Click Here " rel="noopener noreferrer"> Click Here </b> <FaDownload />
                                            </a> &nbsp;to Download Self Declaration. Sign the document & upload <span style={{ color: 'blue', fontWeight: 'bold' }}>(In English)</span> <br /><br />
                                            <a href="https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/OBMMS_UPLOADS/1749800559146_623299402750_selfAffidavitDesc.pdf" className="text-success" target="blank" rel="noopener noreferrer" >
                                                <b className="headlin text-success" title="పై లింక్  నుండి  స్వీయ ధృవీకరణ పత్రాన్ని డౌన్‌లోడ్ చేసి సంతకం చేయండి – ఇక్కడ క్లిక్ చేయండి"> Click Here </b> <FaDownload />
                                            </a> &nbsp;స్వీయ ధృవీకరణ డౌన్లోడ్ చేసుకోండి. డాక్యుమెంట్ సంతకం చేసి అప్‌లోడ్ చేయండి. <span style={{ color: 'blue', fontWeight: 'bold' }}>(In Telugu)</span>
                                        </h6>
                                    </div>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                        <jnb.InputGroup className="mb-3">
                                            <label className='d-block w-100 mb-1'>Passport Size Photo(పాస్‌పోర్ట్ సైజ్ ఫోటో)</label>
                                            <input type="File" className="form-control" name="photoDesc" autoComplete="off" disabled={showData?.renewal === true}
                                                onChange={(e) => {
                                                    let fileVal = Formik?.values?.aadhaarNo;
                                                    let filename = fileVal + "_photoDesc"
                                                    if (fileVal) {
                                                        EmpanelImageBucket(e, Formik, "photoDesc", filename)
                                                    }
                                                    else {
                                                        Sweetalert("Please Enter Your Aadhaar", "warning")
                                                        e.target.value = ""
                                                    }
                                                }}
                                                title="Upload Passport Size Photo(పాస్‌పోర్ట్ సైజ్ ఫోటో అప్లోడ్ చేయండి)"
                                            />
                                            {Formik?.values?.photoDesc !== "" && (
                                                <jnb.Button
                                                    type="button"
                                                    className="btn btn-primary ms-2 p-2 pt-1 "
                                                    onClick={() => {
                                                        ViewImage(Formik?.values?.photoDesc);
                                                        // handleView(Formik?.values?.photoDesc)
                                                    }}
                                                >
                                                    <BsEye></BsEye>
                                                </jnb.Button>
                                            )}
                                            {/* <Field type="hidden" name="photoDesc" /> */}
                                            <ErrorMessage name="photoDesc" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mt-4" >
                                        <jnb.InputGroup className="mb-3">
                                            <label className='d-block w-100 mb-1'>Aadhar Letter (ఆధార్ పత్రం)</label>
                                            {/* <div className="d-flex align-items-center "> */}
                                            <input type="file" className="form-control " name="aadhaarPhotoDesc" autoComplete="off" disabled={showData?.renewal === true}
                                                onChange={(e) => {
                                                    let fileVal = Formik?.values?.aadhaarNo;
                                                    let filename = fileVal + "_aadhaarPhotoDesc"
                                                    if (fileVal) {
                                                        EmpanelImageBucket(e, Formik, "aadhaarPhotoDesc", filename)
                                                    }
                                                    else {
                                                        Sweetalert("Please Enter Your Aadhaar", "warning")
                                                        e.target.value = ""
                                                    }
                                                }}
                                                title="Upload Aadhar Letter (ఆధార్ పత్రం అప్లోడ్ చేయండి)"
                                            />
                                            {Formik?.values?.aadhaarPhotoDesc !== "" && (
                                                <jnb.Button
                                                    type="button"
                                                    className="btn btn-primary ms-2 p-2 pt-1"
                                                    onClick={() => {
                                                        ViewImage(Formik?.values?.aadhaarPhotoDesc);
                                                        // handleView(Formik?.values?.aadhaarPhotoDesc)
                                                    }}
                                                >
                                                    <BsEye></BsEye>
                                                </jnb.Button>
                                            )}
                                            {/* <Field type="hidden" name="aadhaarPhotoDesc" /> */}
                                            <ErrorMessage name="aadhaarPhotoDesc" component="div" className="text-error" />
                                            {/* </div> */}
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mt-4" >
                                        <jnb.InputGroup className="mb-3">
                                            <label className='d-block w-100 mb-1'>Self Declaration(స్వీయ ధృవీకరణ)</label>
                                            <input type="file" className="form-control " name="selfAffidavitDesc" autoComplete="off" disabled={showData?.renewal === true}
                                                onChange={(e) => {
                                                    let fileVal = Formik?.values?.aadhaarNo;
                                                    let filename = fileVal + "_selfAffidavitDesc"
                                                    if (fileVal) {
                                                        EmpanelImageBucket(e, Formik, "selfAffidavitDesc", filename)
                                                    }
                                                    else {
                                                        Sweetalert("Please Enter Your Aadhaar", "warning")
                                                        e.target.value = ""
                                                    }
                                                }}
                                                title="Upload Self Affidavit(స్వీయ ధృవీకరణ అప్లోడ్ చేయండి)"
                                            />
                                            {Formik?.values?.selfAffidavitDesc !== "" && (
                                                <jnb.Button
                                                    type="button"
                                                    className="btn btn-primary ms-2 p-2 pt-1"
                                                    onClick={() => {
                                                        ViewImage(Formik?.values?.selfAffidavitDesc);
                                                        // handleView(Formik?.values?.selfAffidavitDesc)
                                                    }}
                                                >
                                                    <BsEye></BsEye>
                                                </jnb.Button>
                                            )}
                                            {/* <Field type="hidden" name="selfAffidavitDesc" /> */}
                                            <ErrorMessage name="selfAffidavitDesc" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                </jnb.Row>
                                <jnb.Row className="pt-0">
                                    <div className="inner-herbpage-service-title-sub mb-2">
                                        <h1 className="mb-2">Payment(చెల్లింపు)</h1>
                                        <h6 className="text-danger">
                                            Registration fee ₹50 One Time and yearly Contribution ₹12(నమోదు ఫీజు ₹50 మరియు వార్షిక చందా ₹12) .</h6>
                                    </div>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                        <jnb.InputGroup className="">
                                            <label>Years(సంవత్సరాలు): </label>
                                            <Field as="select" className="form-control w-100 mt-3" name="workYears" disabled={!Formik?.values.dob || showData?.renewal === true} autoComplete="off"
                                                onChange={(e) => {
                                                    handleYearChange(e);
                                                    Formik.handleChange(e);
                                                }}
                                                title="select your option(మీ ఎంపికను ఎంచుకోండి)"
                                            >
                                                <option value="">---select---</option>
                                                {options.map((year) => (
                                                    <option key={year} value={year}>{year}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="workYears" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    {showData?.renewal === true ? (
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                            <jnb.InputGroup className="">
                                                <label>₹Renewal Amount(మొత్తం)</label>
                                                <Field type="text" className="form-control w-100 mt-3" name="renewalamount" disabled autoComplete="off" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                    ) : (<jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-3">
                                        <jnb.InputGroup className="">
                                            <label>₹Amount(మొత్తం)</label>
                                            <Field type="text" className="form-control w-100 mt-3" name="amount" disabled autoComplete="off" />
                                        </jnb.InputGroup>
                                    </jnb.Col>

                                    )}
                                </jnb.Row>
                                <jnb.Row className="pt-0">
                                    <jnb.Col xs={12} className="alert alert-warning">
                                        <Field
                                            type="checkbox"
                                            name="selfCheck"
                                            className="form-sub me-2" autoComplete="off"
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                Formik.setFieldValue('selfCheck', isChecked ? true : null);
                                            }} disabled={showData?.renewal === true}
                                        />
                                        I hereby declare that the information furnished herein is true and correct to the best of my knowledge.
                                        I understand that if any part of the information is found to be false or incorrect at a later stage,
                                        I shall be liable for legal action, including cancellation of my registration as a beneficiary,
                                        and recovery of any amount disbursed to me or my family members under any scheme of the Andhra Pradesh Building and Other Construction Workers Welfare Board,
                                        Vijayawada, along with applicable interest and penalties as determined by the Board.

                                        (నాకు తెలిసిన మేరకు పైన తెలిపిన వివరాలు యథార్ధమని ఏవైనా తప్పుగా గాని / అసత్యముగా గానీ కనుగొనబడినట్లయితే ప్రభుత్వం వారు చట్టపరంగా తీసుకునే ఎటువంటి చర్యలకైనా నేనే బాధ్యుడిననీ తెలియజేసుకుంటున్నాను.
                                        అలాగే, లబ్ధిదారుగా నా పెరును రద్దుచేయటకు, APBOCWW బోర్దుద్వారా అమలయ్యే వివిధ పథకాల ద్వారా నేను గాని, నా కుటుంబ సభ్యులు గాని పొందిన ఎటువంటి లబ్ధినైనా వడ్డీ మరియు జరిమానాతో సహా తిరిగి చెల్లించుటకు అంగీకరిస్తూ,
                                        ప్రభుత్వము తీసుకునే అన్ని చర్యలకు నేను మరియు నా కుటుంబ సభ్యులు బాధ్యత వహించగల వారమని తెలియజేస్తున్నాను.)

                                        <ErrorMessage name="selfCheck" component="div" className="text-error" />
                                    </jnb.Col>
                                </jnb.Row>
                                {/* <div className='text-end mt-0'>
                            <button type="submit" className="btn btn-success btn-md">Proceed to Payment</button>
                        </div> */}
                                <div className='text-end mt-0'>
                                    {scode === "03" ?
                                        <button
                                            type="submit"
                                            className="btn btn-success btn-md"
                                            onClick={() => handlePreviewClick}
                                        >
                                            Preview
                                        </button>
                                        : <>
                                            <button
                                                type="button"
                                                className="btn btn-success btn-md"
                                                onClick={() => submitvalues(Formik.values)}
                                            >
                                                Pay Renewal Amount
                                            </button>
                                        </>}
                                </div>
                            </>
                        )}
                        {(scode === "01" && showData && showData?.renewal === false) && (
                            <>
                                {/* <div className='mt-4'><h5 onClick={handleprint} >
                                           <b > Click Here </b> <FaHandPointRight size={30} />&nbsp;
                                           <button className="btn btn-primary" variant="primary">Print&nbsp;
                                               <FaPrint title="Print" style={{ fontSize: '22px' }} />
                                           </button>
                                       </h5> */}
                                {/* <button type="button" className="btn btn-secondary btn-md" onClick={handleprint}> */}
                                {/* <FaPrint size={20} /> &nbsp;Print&emsp; */}
                                {/* </button> */}

                                {/* {(showData.amount_status !== 'F' && showData.amount_status !== 'N') && (

                                        <div className="float-end px-4 no-print">
                                            <a onClick={()=>navigate("/IdCard")} className="text-primary text-decoration-underline" style={{ cursor: "pointer",fontSize: '16px' }}>
                                                View Your Worker ID
                                            </a>
&nbsp;
                                            <b > Click Here </b> <FaHandPointRight size={30} />&nbsp;
                                            <button className="btn btn-primary" variant="primary" onClick={handleprint}>Print&nbsp;
                                                <FaPrint title="Print" style={{ fontSize: '22px' }} />
                                            </button>
                                        </div>
                                    )} */}
                                <div className="p-0 mt-3" ref={componentRef}>
                                    <div className="print-wrapper">
                                        <div className="print-section">
                                            {(showData.amount_status !== 'F' && showData.amount_status !== 'N') && (
                                                <div className="float-end px-4 no-print" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                    {showData.is_alo_verified === true ? (
                                                        <button
                                                            className="btn btn-success"
                                                            onClick={() => navigate("/IdCard")}
                                                            style={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                fontSize: "13px",
                                                                padding: "6px 10px",
                                                            }}
                                                        >
                                                            View Your Worker ID
                                                        </button>
                                                    ) : (
                                                        <div
                                                            style={{
                                                                color: showData.is_alo_verified === null ? "orange" : "red",
                                                                fontWeight: "bold",
                                                                fontSize: "15px",
                                                            }}
                                                        >
                                                            {/* {showData.is_alo_verified === null
          ? "Waiting for ALO Approval"
          : "Verification Declined  {"\n"}by ALO} */}
                                                            {showData.is_alo_verified === null ? (
                                                                "Waiting for ALO Approval"
                                                            ) : (
                                                                <>
                                                                    Verification Declined <br /> by ALO
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                    <b>Click Here</b>
                                                    <FaHandPointRight size={19} />
                                                    <button
                                                        className="btn btn-primary"
                                                        variant="primary"
                                                        onClick={handleprint}
                                                        style={{
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            fontSize: "14px",
                                                            padding: "6px 10px",
                                                        }}
                                                    >
                                                        Print&nbsp;
                                                        <FaPrint title="Print" style={{ fontSize: "16px" }} />
                                                    </button>
                                                </div>
                                            )}
                                            <h5 style={{ textAlign: 'center', whiteSpace: 'pre-line', color: '#074079' }} >
                                                <strong>
                                                    ఆంధ్ర ప్రదేశ్ భవన మరియు ఇతర నిర్మాణ రంగ కార్మికుల నిబంధనలు, 1999 రూల్ 33ఏ (2) {"\n"} భవన మరియు ఇతర నిర్మాణ కార్మికునిగా రిజిస్టర్ చేసుకొనుటకు దరఖాస్తు.
                                                </strong>
                                            </h5>
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1>Basic Details(ప్రాథమిక వివరాలు)</h1>
                                                </div>
                                                <div className="personal-row personal-roweducation">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped">
                                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                                <tr>
                                                                    <td>Worker ID(కార్మిక గుర్తింపు సంఖ్య)</td>
                                                                    <th>{showData.worker_id}</th>
                                                                    <td>Applicant Name(దరఖాస్తుదారు పేరు)</td>
                                                                    <th>{showData.first_name} {showData.last_name}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>Aadhaar No(ఆధార్ సంఖ్య).</td>
                                                                    <th>
                                                                        {showData.mask_aadhaar}
                                                                    </th>
                                                                    <td>Gender(లింగం)</td>
                                                                    <th>{showData.gender === 'M' ? 'Male' : showData.gender === 'F' ? 'Female' : 'Transgender'}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>Date of Birth(పుట్టిన తేది)</td>
                                                                    <th>{moment(showData.dob).format("DD-MM-YYYY")}</th>
                                                                    <td>Phone No(ఫోన్ నంబర్)</td>
                                                                    <th>{showData.phone_no}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>Religion(మతం)</td>
                                                                    <th>{showData.religiondesc}</th>
                                                                    <td>Caste(కులం)</td>
                                                                    <th>{showData.caste_desc}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>Sub Caste(ఉప కులం)</td>
                                                                    <th>{showData.sub_caste_desc}</th>
                                                                    <td>Marital Status(వివాహ స్థితి)</td>
                                                                    <th>{showData.marital_status}</th>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1>Family Details(కుటుంబ వివరాలు)</h1>
                                                </div>
                                                <div className="personal-row personal-roweducation">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th>Member Name (సభ్యుని పేరు)</th>
                                                                    <th>Relation (బంధుత్వం)</th>
                                                                    <th>Member DOB (సభ్యుని పుట్టిన తేదీ)</th>
                                                                    <th>Aadhaar No. (ఆధార్ సంఖ్య)</th>
                                                                    <th>Is He/She Nominee (అతను/ ఆమె నామినీనా)? </th>
                                                                    <th>Benefit % (ప్రయోజన శాతం?)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {showData.fam_details?.map((member, index) => (
                                                                    <tr key={index}>
                                                                        <td>{member.member_name}</td>
                                                                        <td>
                                                                            {{
                                                                                '1': 'Mother(తల్లి)',
                                                                                '2': 'Father(తండ్రి)',
                                                                                '3': 'Brother(అన్న / తమ్ముడు)',
                                                                                '4': 'Sister(అక్క / చెల్లి)',
                                                                                '5': 'Grand Father(తాతయ్య)',
                                                                                '6': 'Grand Mother(అమ్మమ్మ / నానమ్మ)',
                                                                                '7': 'Spouse(జీవిత భాగస్వామి)',
                                                                                '8': 'Daughter(కుమార్తె)',
                                                                                '9': 'Son(కుమారుడు)',
                                                                            }[member.relation] || ''}
                                                                        </td>
                                                                        <td>{moment(member.member_dob).format("DD-MM-YYYY")}</td>
                                                                        <td>{member.member_uid}</td>
                                                                        <td>{member.is_nominee === "Y" ? "Yes (అవును)" : "No(కాదు)"}</td>
                                                                        <td>{member.nominee_percentage}%</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1>Bank Details(బ్యాంక్ వివరాలు) </h1>
                                                </div>
                                                <div className="personal-row personal-roweducation">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped">
                                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                                <tr>
                                                                    <td>IFSC Code(ఐఎఫ్‌ఎస్‌సి కోడ్)</td>
                                                                    <th>{showData.ifsc_code}</th>
                                                                    <td>Bank Name(బ్యాంకు పేరు)</td>
                                                                    <th>{showData.bank_name}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>Branch Name(శాఖ పేరు)</td>
                                                                    <th>{showData.branch_name}</th>
                                                                    <td>Bank Account No(బ్యాంక్ ఖాతా సంఖ్య)</td>
                                                                    <th>{showData.bank_account_no}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>Name in Bank(బ్యాంకులో పేరు)</td>
                                                                    <th>{showData.name_in_bank}</th>
                                                                    <td>Bank Passbook(1st page)(బ్యాంక్ పాస్‌బుక్ (మొదటి పేజీ))</td>
                                                                    {showData.upload_bank_photo && (
                                                                        <button
                                                                            onClick={() => ViewImage(showData.upload_bank_photo)}
                                                                            style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                                                                        >
                                                                            <img
                                                                                src={config.url.FILE_DOWNLOAD_URL + showData.upload_bank_photo}
                                                                                alt="Uploaded"
                                                                                style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                                            />
                                                                        </button>

                                                                        // <SecureImage filePath={filePaths.bankPhoto} />
                                                                    )}
                                                                    <FaDownload
                                                                        size={40}
                                                                        style={{ cursor: 'pointer', color: '#007bff' }}
                                                                        onClick={() => {
                                                                            const fileUrl = config.url.FILE_DOWNLOAD_URL + filePaths.bankPhoto;
                                                                            const link = document.createElement('a');
                                                                            link.href = fileUrl;
                                                                            link.download = filePaths.bankPhoto.split('/').pop();
                                                                            document.body.appendChild(link);
                                                                            link.click();
                                                                            document.body.removeChild(link);
                                                                        }}
                                                                    />
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1>Address for Communication(చిరునామా) </h1>
                                                    <h1 style={{ fontSize: "18px" }}>Present Address(ప్రస్తుత చిరునామా)</h1>
                                                </div>
                                                <div className="personal-row personal-roweducation">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped">
                                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>

                                                                <tr>
                                                                    <td> District(జిల్లా)</td>
                                                                    <th>{showData.present_district}</th>
                                                                    <td> Mandal(మండలం)</td>
                                                                    <th>{showData.present_mandal}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td> Village(గ్రామం)</td>
                                                                    <th>{showData.present_village}</th>
                                                                    <td> Pincode(పిన్‌కోడ్)</td>
                                                                    <th>{showData.present_pincode}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td> Door No(ఇంటి నంబర్)</td>
                                                                    <th>{showData.present_door_no}</th>
                                                                    <td> Address(చిరునామా)</td>
                                                                    <th>{showData.present_address}</th>

                                                                </tr>
                                                                <tr>
                                                                    <td>Division/Ward Number(డివిజన్/వార్డ్ నంబర్)</td>
                                                                    <th>{showData.present_division}</th>
                                                                    <td>Landmark/Locality(ల్యాండ్‌మార్క్/ప్రాంతం)</td>
                                                                    <th>{showData.present_land_mark}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>town/city(నగరం/పట్టణం)</td>
                                                                    <th>{showData.present_city}</th>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1 style={{ fontSize: "18px" }}> Permanent Address(శాశ్వత చిరునామా) </h1>
                                                </div>
                                                <div className="personal-row personal-roweducation">
                                                    <p><strong>Is your Present address same as Permanent address (మీ ప్రస్తుత చిరునామా మరియు శాశ్వత చిరునామా ఒకటేనా)?</strong> {showData.is_permanent === "Y" ? "Yes(అవును)" : "No(కాదు)"}</p>
                                                    {showData.is_permanent === "N" && (
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-striped">
                                                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                                    <tr>
                                                                        <td>District(జిల్లా)</td>
                                                                        <th>{showData.permanent_district}</th>
                                                                        <td>Mandal(మండలం)</td>
                                                                        <th>{showData.permanent_mandal}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Village(గ్రామం)</td>
                                                                        <th>{showData.permanent_village}</th>
                                                                        <td>Pincode(పిన్‌కోడ్)</td>
                                                                        <th>{showData.permanent_pincode}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Door No(ఇంటి నంబర్)</td>
                                                                        <th>{showData.permanent_door_no}</th>
                                                                        <td>Address(చిరునామా)</td>
                                                                        <th>{showData.permanent_address}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Division/Ward Number(డివిజన్/వార్డ్ నంబర్)</td>
                                                                        <th>{showData.permanent_division}</th>
                                                                        <td>Landmark/Locality(ల్యాండ్‌మార్క్/ప్రాంతం)</td>
                                                                        <th>{showData.permanent_land_mark}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>town/city(నగరం/పట్టణం)</td>
                                                                        <th>{showData.permanent_city}</th>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1>Other Details(ఇతర వివరాలు)</h1>
                                                </div>
                                                <div className="personal-row personal-roweducation">
                                                    <p><strong>Is he/she is an MGNREGS worker(అతను/ఆమె మహాత్మా గాంధీ జాతీయ గ్రామీణ ఉపాధి కార్మికులా)?: </strong> {showData.is_nregs === "Y" ? "Yes(అవును)" : "No(కాదు)"}</p>
                                                    {showData.is_nregs === "Y" && (
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-striped">
                                                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                                    <tr>
                                                                        <td>Job card Number(జాబ్ కార్డ్ నంబర్)</td>
                                                                        <th>{showData.job_card_no}</th>
                                                                        <td>No.of work days copy(పని రోజుల ప్రతులు)</td>
                                                                        <th> {showData.word_days_copy && (

                                                                            <button
                                                                                onClick={() => ViewImage(showData.word_days_copy)}
                                                                                style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                                                                            >
                                                                                <img
                                                                                    src={config.url.FILE_DOWNLOAD_URL + showData.word_days_copy}
                                                                                    alt="Uploaded"
                                                                                    style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                                                />
                                                                            </button>

                                                                            // <img
                                                                            //     src={config.url.FILE_DOWNLOAD_URL + showData.word_days_copy}
                                                                            //     alt="Uploaded"
                                                                            //     style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                                            // />

                                                                            // <SecureImage filePath={filePaths.noOfworkdays} />

                                                                            //   <jnb.Button
                                                                            //     type="button"
                                                                            //     className="btn btn-primary ms-2 p-2 pt-1"
                                                                            //     onClick={() => viewImage(showData.word_days_copy)}
                                                                            //   >
                                                                            //     <BsEye className="me-1" />
                                                                            //     View
                                                                            //   </jnb.Button>
                                                                        )}
                                                                            <FaDownload
                                                                                size={40}
                                                                                style={{ cursor: 'pointer', color: '#007bff' }}
                                                                                onClick={() => {
                                                                                    const fileUrl = config.url.FILE_DOWNLOAD_URL + filePaths.noOfworkdays;
                                                                                    const link = document.createElement('a');
                                                                                    link.href = fileUrl;
                                                                                    link.download = filePaths.noOfworkdays.split('/').pop();
                                                                                    document.body.appendChild(link);
                                                                                    link.click();
                                                                                    document.body.removeChild(link);
                                                                                }}
                                                                            /></th>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1>Trade Union(కార్మిక సంఘం)</h1>
                                                </div>
                                                <div className="personal-row personal-roweducation">
                                                    <p><strong>Is the worker a member of any trade union (కార్మికుడు/కార్మికురాలు ఏదైనా కార్మిక సంఘంలో సభ్యుడా/సభ్యురాలా)? : </strong> {showData.is_union_member === "Y" ? "Yes(అవును)" : "No(కాదు)"}</p>
                                                    {showData.is_union_member === "Y" && (
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-striped">
                                                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                                    <tr>
                                                                        <td>Union Name(యూనియన్ పేరు)</td>
                                                                        <th>{showData.union_name}</th>
                                                                        <td>Registration No(నమోదు సంఖ్య)</td>
                                                                        <th> {showData.reg_no}</th>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1>Work Place Details(ప్రస్తుత పని స్థలం వివరాలు)</h1>
                                                </div>
                                                <div className="personal-row personal-roweducation">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped">
                                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                                <tr>
                                                                    <td>Name of the Employer (యాజమాని పేరు)</td>
                                                                    <th>{showData.emp_name}</th>
                                                                    <td>Name of the Construction Organisation(నిర్మాణ సంస్థ పేరు)</td>
                                                                    <th>{showData.present_office_name}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>Trade of work(వృత్తి/పని)</td>
                                                                    <th>{showData.type_of_work}</th>
                                                                    <td>Do you need any training(మీకు శిక్షణ అవసరమా)?</td>
                                                                    <th>{showData.work_capability === "Y" ? "Yes(అవును)" : "No(కాదు)"}</th>
                                                                    {/* <th>{showData.work_capability === '1' ? 'High Skilled' : showData.work_capability === '2' ? 'Skilled' : showData.work_capability === '3' ? 'Semi Skilled' : 'Un-Skilled'}</th> */}
                                                                </tr>
                                                                <tr>
                                                                    <td>District(జిల్లా)</td>
                                                                    <th>{showData.office_district}</th>
                                                                    <td>Mandal(మండలం)</td>
                                                                    <th>{showData.office_mandal}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>Village(గ్రామం)</td>
                                                                    <th>{showData.office_village}</th>
                                                                    <td>Pincode(పిన్ కోడ్)</td>
                                                                    <th>{showData.office_pincode}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>Door No(ఇంటి నంబర్)</td>
                                                                    <th>{showData.office_door_no}</th>
                                                                    <td>Address(చిరునామా)</td>
                                                                    <th>{showData.office_address}</th>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1 style={{ fontSize: "18px" }}> Migrant Worker(వలస కార్మికుడు) </h1>
                                                </div>
                                                <div className="personal-row personal-roweducation">
                                                    <p><strong>Are you a migrant worker(మీరు వలస కార్మికుడా)?</strong> {showData.isMigrant === "Y" ? "Yes(అవును)" : "No(కాదు)"}</p>
                                                    {/* {showData.isMigrant   === "Y" && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                          <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                            <tr>
                              <td>District(జిల్లా)</td>
                              <th>{showData.permanent_district}</th>
                              <td>Mandal(మండలం)</td>
                              <th>{showData.permanent_mandal}</th>
                            </tr>
                            <tr>
                              <td>Village(గ్రామం)</td>
                              <th>{showData.permanent_village}</th>
                              <td>Pincode(పిన్‌కోడ్)</td>
                              <th>{showData.permanent_pincode}</th>
                            </tr> 
                          </tbody>
                        </table>
                      </div>
  )} */}
                                                </div>
                                            </div>
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1>Uploads(అప్‌లోడ్లు)</h1>
                                                </div>
                                                <div className="personal-row personal-roweducation">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped">
                                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                                <tr>
                                                                    <td>Passport Size Photo(పాస్‌పోర్ట్ సైజ్ ఫోటో)</td>
                                                                    {showData.upload_photo && (
                                                                        <button
                                                                            onClick={() => ViewImage(showData.upload_photo)}
                                                                            style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                                                                        >
                                                                            <img
                                                                                src={config.url.FILE_DOWNLOAD_URL + showData.upload_photo}
                                                                                alt="Uploaded"
                                                                                style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                                            />
                                                                        </button>
                                                                        // <SecureImage filePath={filePaths.photo} />
                                                                    )}
                                                                    <FaDownload
                                                                        size={40}
                                                                        style={{ cursor: 'pointer', color: '#007bff' }}
                                                                        onClick={() => {
                                                                            const fileUrl = config.url.FILE_DOWNLOAD_URL + filePaths.photo;
                                                                            const link = document.createElement('a');
                                                                            link.href = fileUrl;
                                                                            link.download = filePaths.photo.split('/').pop();
                                                                            document.body.appendChild(link);
                                                                            link.click();
                                                                            document.body.removeChild(link);
                                                                        }}
                                                                    />
                                                                    <td>Aadhar Letter (ఆధార్ పత్రం)</td>
                                                                    {showData.upload_aadhaar_photo && (
                                                                        <button
                                                                            onClick={() => ViewImage(showData.upload_aadhaar_photo)}
                                                                            style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                                                                        >
                                                                            <img
                                                                                src={config.url.FILE_DOWNLOAD_URL + showData.upload_aadhaar_photo}
                                                                                alt="Uploaded"
                                                                                style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                                            />
                                                                        </button>
                                                                        // <SecureImage filePath={filePaths.adhaar} />
                                                                    )}
                                                                    <FaDownload
                                                                        size={40}
                                                                        style={{ cursor: 'pointer', color: '#007bff' }}
                                                                        onClick={() => {
                                                                            const fileUrl = config.url.FILE_DOWNLOAD_URL + filePaths.adhaar;
                                                                            const link = document.createElement('a');
                                                                            link.href = fileUrl;
                                                                            link.download = filePaths.adhaar.split('/').pop();
                                                                            document.body.appendChild(link);
                                                                            link.click();
                                                                            document.body.removeChild(link);
                                                                        }}
                                                                    />
                                                                    {/* <th> {showData.upload_aadhaar_photo && (
                            <jnb.Button
                              type="button"
                              className="btn btn-primary ms-2 p-2 pt-1"
                              onClick={() => viewImage(showData.upload_aadhaar_photo)}
                            >
                              <BsEye className="me-1" />
                              View
                            </jnb.Button>
                          )}</th> */}
                                                                </tr>
                                                                <tr>
                                                                    <td>Self Affidavit(స్వీయ ధృవీకరణ)</td>
                                                                    {/* <th> {showData.upload_self_affidavit && (
                            <jnb.Button
                              type="button"
                              className="btn btn-primary ms-2 p-2 pt-1"
                              onClick={() => viewImage(showData.upload_self_affidavit)}
                            >
                              <BsEye className="me-1" />
                              View
                            </jnb.Button>
                          )}</th> */}
                                                                    {/* {showData.upload_self_affidavit && (
                                                            <img
                                                                src={config.url.FILE_DOWNLOAD_URL + showData.upload_self_affidavit}
                                                                alt="Uploaded"
                                                                style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                            />
                                                        )} */}
                                                                    {showData.upload_self_affidavit && (
                                                                        <>
                                                                            {showData.upload_self_affidavit.toLowerCase().endsWith('.pdf') ? (
                                                                                <FaDownload
                                                                                    size={40}
                                                                                    style={{ cursor: 'pointer', color: '#007bff' }}
                                                                                    onClick={() => {
                                                                                        const fileUrl = config.url.FILE_DOWNLOAD_URL + showData.upload_self_affidavit;
                                                                                        const link = document.createElement('a');
                                                                                        link.href = fileUrl;
                                                                                        link.download = showData.upload_self_affidavit.split('/').pop(); // get file name
                                                                                        document.body.appendChild(link);
                                                                                        link.click();
                                                                                        document.body.removeChild(link);
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                // <img
                                                                                //     src={config.url.FILE_DOWNLOAD_URL + showData.upload_self_affidavit}
                                                                                //     alt="Uploaded"
                                                                                //     style={{ maxWidth: '100px', maxHeight: '100px', cursor: 'pointer' }}
                                                                                // />
                                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                                    <button
                                                                                        onClick={() => ViewImage(showData.upload_self_affidavit)}
                                                                                        style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                                                                                    >
                                                                                        <img
                                                                                            src={config.url.FILE_DOWNLOAD_URL + showData.upload_self_affidavit}
                                                                                            alt="Uploaded"
                                                                                            style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                                                        />
                                                                                    </button>

                                                                                    {/* <SecureImage filePath={filePaths.affidavit} /> */}
                                                                                    <FaDownload
                                                                                        size={25}
                                                                                        style={{ cursor: 'pointer', color: '#007bff' }}
                                                                                        onClick={() => {
                                                                                            const fileUrl = config.url.FILE_DOWNLOAD_URL + filePaths.affidavit;
                                                                                            const link = document.createElement('a');
                                                                                            link.href = fileUrl;
                                                                                            link.download = filePaths.affidavit.split('/').pop();
                                                                                            document.body.appendChild(link);
                                                                                            link.click();
                                                                                            document.body.removeChild(link);
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}

                                                                    {/* {showData.upload_self_affidavit && (
                                                            // <img
                                                            //     src={config.url.FILE_DOWNLOAD_URL + showData.upload_self_affidavit}
                                                            //     alt="Uploaded"
                                                            //     style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                            // />
                                                            <SecureImage filePath={filePaths.affidavit} />
                                                        )} */}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1>Payment(చెల్లింపు వివరాలు)</h1> </div>
                                                <div className="personal-row personal-roweducation">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped">
                                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                                <tr>
                                                                    <td>Years(సంవత్సరాలు):</td>
                                                                    <th>{showData.work_year}</th>
                                                                    <td>₹Amount(మొత్తం)</td>
                                                                    <th>₹{showData.amount}</th>
                                                                    <td>Payment Status(చెల్లింపు స్థితి)</td>
                                                                    <th style={{ color: showData.amount_status === 'S' ? 'green' : 'red' }}>
                                                                        {showData.amount_status === 'S' ? 'SUCCESS' : 'FAILURE'}
                                                                    </th>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className="print-section">
                                                <div className="inner-herbpage-service-title-sub">
                                                    <h1>Payment History(చెల్లింపు వివరాలు)</h1> </div>
                                                <div className="personal-row personal-roweducation">
                                                    <div className="table-responsive">
                                                        <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-2"
                                                            style={{ border: '3px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                                                        >
                                                            <thead style={{ border: "1px solid black" }}>
                                                                <tr>
                                                                    <th>S.NO</th>
                                                                    <th>Transaction Id(లావాదేవీ ఐడీ)</th>
                                                                    <th>Amount Paid(చెల్లించిన మొత్తం)</th>
                                                                    <th>Payment Date(చెల్లింపు తేదీ)</th>
                                                                    <th>Payment Category(చెల్లింపు వర్గం)</th>
                                                                    <th>Payment Status(చెల్లింపు స్థితి)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ShowTxnHistory && ShowTxnHistory.length > 0 ? (
                                                                    ShowTxnHistory?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{item.transaction_id || "N/A"}</td>
                                                                            <td>{item.transaction_amount?.toFixed(2) || "0.00"}</td>
                                                                            <td>
                                                                                {item.payment_status_updated_on
                                                                                    ? new Date(item.payment_status_updated_on).toLocaleString("en-GB", {
                                                                                        day: "2-digit",
                                                                                        month: "2-digit",
                                                                                        year: "numeric",
                                                                                        hour: "2-digit",
                                                                                        minute: "2-digit",
                                                                                        second: "2-digit",
                                                                                    }).replace(",", " /")
                                                                                    : "N/A"}
                                                                            </td>
                                                                            <td style={{ color: "black", fontWeight: "bold" }}>
                                                                                {item.payment_category || "N/A"}
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    color:
                                                                                        item.payment_status?.toUpperCase() === "SUCCESS"
                                                                                            ? "green"
                                                                                            : item.payment_status?.toUpperCase() === "FAIL"
                                                                                                ? "red"
                                                                                                : "black",
                                                                                    fontWeight: "bold",
                                                                                }}
                                                                            >
                                                                                {item.payment_status || "N/A"}
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={6} className="text-center">
                                                                            <div className="text-danger fw-bold py-2 w-100" style={{ textAlign: 'center' }}>
                                                                                *** No Payment History Found ***
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <jnb.Row> */}
                                            {/* <jnb.Col xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}  className="pt-4 mt-2"> */}
                                            <div className='text-end mt-0'>
                                                {(showData.amount_status === 'F' || showData.amount_status === 'N') && (
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary"
                                                        onClick={() => {
                                                            payment(Formik.values);
                                                        }}
                                                    >
                                                        Proceed To Pay
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        {/* </jnb.Col> */}
                                        {/* </jnb.Row> */}
                                    </div>
                                </div>
                            </>
                        )}
                        <jnb.Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} size="xl" centered scrollable backdrop='static'>
                            <jnb.Modal.Header closeButton>
                                <jnb.Modal.Title className="w-100 text-center">Preview Details</jnb.Modal.Title>
                            </jnb.Modal.Header>
                            <jnb.Modal.Body>
                                <h5 style={{ textAlign: 'center', whiteSpace: 'pre-line', color: '#074079' }} >
                                    <strong>
                                        ఆంధ్ర ప్రదేశ్ భవన మరియు ఇతర నిర్మాణ రంగ కార్మికుల నిబంధనలు, 1999 రూల్ 33ఏ (2){"\n"} భవన మరియు ఇతర నిర్మాణ కార్మికునిగా రిజిస్టర్ చేసుకొనుటకు దరఖాస్తు.
                                    </strong>
                                </h5>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Basic Details(ప్రాథమిక వివరాలు)</h1>
                                </div>
                                <div className="personal-row personal-roweducation">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                <tr>
                                                    <td>Aadhaar No(ఆధార్ సంఖ్య): </td>
                                                    <th>{Formik.values.aadhaarNo}</th>
                                                    <td>First Name(మొదటి పేరు):</td>
                                                    <th>{Formik.values.firstName}</th>
                                                </tr>
                                                <tr>
                                                    <td>Last(Sur) Name(చివరి పేరు / ఇంటి పేరు):</td>
                                                    <th>{Formik.values.lastName}</th>
                                                    <td>Gender(లింగం)</td>
                                                    <th>{Formik.values?.gender === 'M' ? 'Male' : Formik.values?.gender === 'F' ? 'Female' : 'Transgender'}</th>
                                                </tr>
                                                <tr>
                                                    <td>Marital Status(వివాహ స్థితి)</td>
                                                    <th>{Formik.values.maritalStatus}</th>
                                                    <td>Religion(మతం)</td>
                                                    <th>
                                                        {showList?.religions?.find(r => r.religionid.toString() == Formik.values.religion)?.religiondesc || ''}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td>Caste(కులం)</td>
                                                    <th>
                                                        {showCasteList?.find(c => c.caste_code.toString() == Formik.values.caste)?.caste_desc || ''}
                                                    </th>
                                                    <td>Sub Caste(ఉప కులం)</td>
                                                    <th>
                                                        {showSubCasteList?.find(scs => scs.sub_caste_code.toString() == Formik.values.subCaste)?.sub_caste_desc || ''}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td>Phone No(ఫోన్ నంబర్) </td>
                                                    <th>{Formik.values.phoneNo}</th>
                                                    <td>DOB(పుట్టిన తేది)</td>
                                                    <th>{moment(Formik.values.dob).format("DD-MM-YYYY")}</th>
                                                </tr>
                                                <tr>
                                                    <td>Father /Husband Name(తండ్రి / భర్త పేరు)</td>
                                                    <th>{Formik.values.fatherName}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Family Details(కుటుంబ వివరాలు)</h1>
                                </div>
                                <div className="personal-row personal-roweducation">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Member Name (సభ్యుని పేరు)</th>
                                                    <th>Relation (బంధుత్వం)</th>
                                                    <th>Member DOB (సభ్యుని పుట్టిన తేదీ)</th>
                                                    <th>Aadhaar No. (ఆధార్ సంఖ్య)</th>
                                                    <th>Is He/She Nominee (అతను/ ఆమె నామినీనా)? </th>
                                                    <th>Benefit % (ప్రయోజన శాతం?)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Formik.values.familydetails?.map((member, index) => (
                                                    <tr key={index}>
                                                        <td>{member.memberName}</td>
                                                        <td>
                                                            {{
                                                                '1': 'Mother(తల్లి)',
                                                                '2': 'Father(తండ్రి)',
                                                                '3': 'Brother(అన్న / తమ్ముడు)',
                                                                '4': 'Sister(అక్క / చెల్లి)',
                                                                '5': 'Grand Father(తాతయ్య)',
                                                                '6': 'Grand Mother(అమ్మమ్మ / నానమ్మ)',
                                                                '7': 'Spouse(జీవిత భాగస్వామి)',
                                                                '8': 'Daughter(కుమార్తె)',
                                                                '9': 'Son(కుమారుడు)',
                                                            }[member.relation] || ''}
                                                        </td>
                                                        <td>{moment(member.memberDob).format("DD-MM-YYYY")}</td>
                                                        <td>{member.memberUid}</td>
                                                        <td>{member.isNomine === "Y" ? "Yes (అవును)" : "No(కాదు)"}</td>
                                                        <td>{member.isNomine === "Y" ? member.nominePer : "-"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Bank Details(బ్యాంక్ వివరాలు)</h1>
                                </div>
                                <div className="personal-row personal-roweducation">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                <tr>
                                                    <td>IFSC Code(ఐఎఫ్‌ఎస్‌సి కోడ్) </td>
                                                    <th>{Formik.values.ifscCode}</th>
                                                    <td>Bank Name(బ్యాంకు పేరు)</td>
                                                    <th>{Formik.values.bankName}</th>
                                                </tr>
                                                <tr>
                                                    <td>Branch Name(శాఖ పేరు)</td>
                                                    <th>{Formik.values.branchName}</th>
                                                    <td>Bank account number(బ్యాంక్ ఖాతా సంఖ్య)</td>
                                                    <th>{Formik.values.bankAccountNo}</th>

                                                </tr>
                                                <tr>
                                                    <td>RE-Enter Bank Account Number</td>
                                                    <th>{Formik.values.rbankAccountNo}</th>
                                                    <td>Name in Bank(బ్యాంకులో పేరు)</td>
                                                    <th>{Formik.values.nameInBank}</th>

                                                </tr>
                                                <tr>
                                                    <td>Bank Passbook(1st page)(బ్యాంక్ పాస్‌బుక్ (మొదటి పేజీ))</td>
                                                    <th>
                                                        {Formik?.values?.bankPhotoDesc && (
                                                            <button
                                                                onClick={() => ViewImage(Formik?.values?.bankPhotoDesc)}
                                                                style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                                                            >
                                                                <img
                                                                    src={config.url.FILE_DOWNLOAD_URL + Formik?.values?.bankPhotoDesc}
                                                                    alt="Uploaded"
                                                                    style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                                />
                                                            </button>
                                                            // <SecureImage filePath={filePaths.bankPhoto} />
                                                        )}

                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Address for Communication(చిరునామా) </h1>
                                    <h1 style={{ fontSize: "18px" }}>Present Address(ప్రస్తుత చిరునామా)</h1>
                                </div>
                                <div className="personal-row personal-roweducation">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                <tr>
                                                    <td>District(జిల్లా)</td>
                                                    <th>{showDist?.find(v => v.districtId == Formik.values.presentDistrictCode)?.distName || ''}</th>
                                                    <td>Mandal(మండలం)</td>
                                                    <th>{showPresentalManList?.find(v => v.mandalCode == Formik.values.presentMadalCode)?.mandalName || ''}</th>
                                                </tr>
                                                <tr>
                                                    <td>Village(గ్రామం)</td>
                                                    {/* <th>{showPresentVillList?.find(v => v.village_code == Formik.values.presentVillageCode)?.village_name || ''}</th> */}
                                                    <th>
                                                        {Formik.values.presentVillageCode == 0
                                                            ? Formik.values.presentOtherVillageName || ''
                                                            : showPresentVillList?.find(
                                                                (v) => v.village_code == Formik.values.presentVillageCode
                                                            )?.village_name || ''}
                                                    </th>
                                                    <td>Pincode(పిన్‌కోడ్)</td>
                                                    <th>{Formik.values.presentPincode}</th>

                                                </tr>
                                                <tr>
                                                    <td>Door No(ఇంటి నంబర్)</td>
                                                    <th>{Formik.values.presentDoorNo}</th>
                                                    <td>Address(చిరునామా)</td>
                                                    <th>{Formik.values.presentAddress}</th>
                                                </tr>
                                                <tr>
                                                    <td>Division/Ward Number(డివిజన్/వార్డ్ నంబర్)</td>
                                                    <th>{Formik.values.presentDivision}</th>
                                                    <td>Landmark/Locality(ల్యాండ్‌మార్క్/ప్రాంతం)</td>
                                                    <th>{Formik.values.presentLandMark}</th>
                                                </tr>
                                                <tr>
                                                    <td>town/city(నగరం/పట్టణం)</td>
                                                    <th>{Formik.values.presentCity}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1> Permanent Address(శాశ్వత చిరునామా) </h1>
                                </div>
                                <div className="personal-row personal-roweducation">
                                    <p><strong>Is your Present address same as Permanent address(మీ ప్రస్తుత చిరునామా మరియు శాశ్వత చిరునామా ఒకటేనా)?</strong> {Formik.values.isPermanent === "Y" ? "Yes(అవును)" : "No(కాదు)"}</p>
                                    {Formik.values.isPermanent === "N" && (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped">
                                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                    <tr>
                                                        <td>District(జిల్లా)</td>
                                                        <th>{showDist?.find(v => v.districtId == Formik.values.permanentDistrictCode)?.distName || ''}</th>
                                                        <td>Mandal(మండలం)</td>
                                                        <th>{showPermntManList?.find(v => v.mandalCode == Formik.values.permanentMadalCode)?.mandalName || ''}</th>
                                                    </tr>
                                                    <tr>
                                                        <td>Village(గ్రామం)</td>
                                                        {/* <th>{showPermntVillList?.find(v => v.village_code == Formik.values.permanentVillageCode)?.village_name || ''}</th> */}
                                                        <th>
                                                            {Formik.values.permanentVillageCode == "0"
                                                                ? Formik.values.permanentOtherVillageName || ''
                                                                : showPermntVillList?.find(
                                                                    (v) => v.village_code == Formik.values.permanentVillageCode
                                                                )?.village_name || ''}
                                                        </th>
                                                        <td>Pincode(పిన్‌కోడ్)</td>
                                                        <th>{Formik.values.permanentPincode}</th>
                                                    </tr>
                                                    <tr>
                                                        <td>Door No(ఇంటి నంబర్)</td>
                                                        <th>{Formik.values.permanentDoorNo}</th>
                                                        <td>Address(చిరునామా)</td>
                                                        <th>{Formik.values.permanentAddress}</th>

                                                    </tr>
                                                    <tr>
                                                        <td>Division/Ward Number(డివిజన్/వార్డ్ నంబర్)</td>
                                                        <th>{Formik.values.permanentDivision}</th>
                                                        <td>Landmark/Locality(ల్యాండ్‌మార్క్/ప్రాంతం)</td>
                                                        <th>{Formik.values.permanentLandMark}</th>
                                                    </tr>
                                                    <tr>
                                                        <td>town/city(నగరం/పట్టణం)</td>
                                                        <th>{Formik.values.permanentCity}</th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Other Details(ఇతర వివరాలు)</h1>
                                </div>
                                <div className="personal-row personal-roweducation">
                                    <p><strong>Is he/she is an MGNREGS worker(అతను/ఆమె మహాత్మా గాంధీ జాతీయ గ్రామీణ ఉపాధి కార్మికులా)?</strong> {Formik.values.isNregs === "Y" ? "Yes(అవును)" : "No(కాదు)"}</p>
                                    {Formik.values.isNregs === "Y" && (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped">
                                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                    <tr>
                                                        <td>Job card Number(జాబ్ కార్డ్ నంబర్)</td>
                                                        <th>{Formik.values.jobCardNo}</th>
                                                        <td>No.of work days copy(పని రోజుల ప్రతులు)</td>
                                                        <th> {Formik?.values?.wordDaysCopyDesc && (
                                                            <button
                                                                onClick={() => ViewImage(Formik?.values?.wordDaysCopyDesc)}
                                                                style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                                                            >
                                                                <img
                                                                    src={config.url.FILE_DOWNLOAD_URL + Formik?.values?.wordDaysCopyDesc}
                                                                    alt="Uploaded"
                                                                    style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                                />
                                                            </button>
                                                            // <SecureImage filePath={filePaths.noOfworkdays} />
                                                        )}</th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Trade Union(కార్మిక సంఘం)</h1>
                                </div>
                                <div className="personal-row personal-roweducation">
                                    <p><strong>Is the worker a member of any trade union (కార్మికుడు/కార్మికురాలు ఏదైనా కార్మిక సంఘంలో సభ్యుడా/సభ్యురాలా)?</strong> {Formik.values.isUnionMember === "Y" ? "Yes(అవును)" : "No(కాదు)"}</p>
                                    {Formik.values.isUnionMember === "Y" && (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped">
                                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                    <tr>
                                                        <td>Union Name(యూనియన్ పేరు)</td>
                                                        <th>{Formik.values.unionName}</th>
                                                        <td>Registration No(నమోదు సంఖ్య)</td>
                                                        <th> {Formik?.values?.regNo}</th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Work Place Details(ప్రస్తుత పని స్థలం వివరాలు)</h1>
                                </div>
                                <div className="personal-row personal-roweducation">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                <tr>
                                                    <td>Name of the Employer(యాజమాని పేరు)</td>
                                                    <th>{Formik.values.empName}</th>
                                                    <td>Name of the Construction Organisation(నిర్మాణ సంస్థ పేరు)</td>
                                                    <th>{Formik.values.presentOfficeName}</th>
                                                </tr>
                                                <tr>
                                                    <td>Trade of work(వృత్తి / పని)</td>
                                                    <th>{Formik.values.typeOfWork}</th>
                                                    <td>Do you need any training(మీకు శిక్షణ అవసరమా)?</td>
                                                    <th>{Formik.values.workCapability === "Y" ? "Yes(అవును)" : "No(కాదు)"}</th>
                                                    {/* <th>{Formik.values.workCapability === '1' ? 'High Skilled(అత్యున్నత నైపుణ్యం)' : Formik.values.workCapability === '2' ? 'Skilled(నైపుణ్యం ఉన్నవారు)' : Formik.values.workCapability === '3' ? 'Semi Skilled (పాషిక నైపుణ్యం లేని వారు)' : 'Un-Skilled(నైపుణ్యం లేని వారు)'}</th> */}
                                                </tr>
                                                <tr>
                                                    <td>District(జిల్లా)</td>
                                                    <th>{showDist?.find(v => v.districtId == Formik.values.officeDistrictCode)?.distName || ''}</th>
                                                    <td>Mandal(మండలం)</td>
                                                    <th>{showOfficeManList?.find(v => v.mandalCode == Formik.values.officeMadalCode)?.mandalName || ''}</th>
                                                </tr>
                                                <tr>
                                                    <td>Village(గ్రామం)</td>
                                                    {/* <th>{showOfficeVillList?.find(v => v.village_code == Formik.values.officeVillageCode)?.village_name || ''}</th> */}
                                                    <th>
                                                        {Formik.values.officeVillageCode == "0"
                                                            ? Formik.values.officeOtherVillageName || '' : showOfficeVillList?.find(
                                                                (v) => v.village_code == Formik.values.officeVillageCode
                                                            )?.village_name || ''}
                                                    </th>
                                                    <td>Pincode(పిన్‌కోడ్)</td>
                                                    <th>{Formik.values.officePincode}</th>
                                                </tr>
                                                <tr>
                                                    <td>Door No(ఇంటి నంబర్)</td>
                                                    <th>{Formik.values.officeDoorNo}</th>
                                                    <td>Address(చిరునామా)</td>
                                                    <th>{Formik.values.officeAddress}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1> Migrant Worker(వలస కార్మికుడు) </h1>
                                </div>
                                <div className="personal-row personal-roweducation">
                                    <p><strong>Are you a migrant worker(మీరు వలస కార్మికుడా)?</strong> {Formik.values.isMigrant === "Y" ? "Yes(అవును)" : "No(కాదు)"}</p>
                                    {/* {Formik.values.isMigrant   === "Y" && (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped">
                                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                    <tr>
                                                        <td>District(జిల్లా)</td>
                                                        <th>{showDist?.find(v => v.districtId == Formik.values.migrantDistrictCode)?.distName || ''}</th>
                                                        <td>Mandal(మండలం)</td>
                                                        <th>{showmigrantManList?.find(v => v.mandalCode == Formik.values.migrantMadalCode)?.mandalName || ''}</th>
                                                    </tr>
                                                    <tr>
                                                        <td>Village(గ్రామం)</td>
                                                         <th>
  {Formik.values.migrantVillageCode == "0"
    ? Formik.values.migrantOtherVillageName || ''
    : showmigrantVillList?.find(
        (v) => v.village_code == Formik.values.migrantVillageCode
      )?.village_name || ''}
</th>
                                                        <td>Pincode(పిన్‌కోడ్)</td>
                                                        <th>{Formik.values.migrantPincode}</th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )} */}
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Uploads(అప్‌లోడ్లు)</h1>
                                </div>
                                <div className="personal-row personal-roweducation">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                <tr>
                                                    <td>Passport Size Photo(పాస్‌పోర్ట్ సైజ్ ఫోటో)</td>
                                                    <th> {Formik?.values?.photoDesc && (
                                                        <button
                                                            onClick={() => ViewImage(Formik?.values?.photoDesc)}
                                                            style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                                                        >
                                                            <img
                                                                src={config.url.FILE_DOWNLOAD_URL + Formik?.values?.photoDesc}
                                                                alt="Uploaded"
                                                                style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                            />
                                                        </button>
                                                        // <SecureImage filePath={filePaths.photo} />
                                                    )}</th>
                                                    <td>Aadhar Letter (ఆధార్ పత్రం)</td>
                                                    <th> {Formik?.values?.aadhaarPhotoDesc && (
                                                        <button
                                                            onClick={() => ViewImage(Formik?.values?.aadhaarPhotoDesc)}
                                                            style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                                                        >
                                                            <img
                                                                src={config.url.FILE_DOWNLOAD_URL + Formik?.values?.aadhaarPhotoDesc}
                                                                alt="Uploaded"
                                                                style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                            />
                                                        </button>

                                                        // <SecureImage filePath={filePaths.adhaar} />

                                                    )}</th>
                                                </tr>
                                                <tr>
                                                    <td>Self Affidavit(స్వీయ ధృవీకరణ)</td>
                                                    {/* <th> {Formik?.values?.selfAffidavitDesc && (
                                                        <img
                                                            src={config.url.FILE_DOWNLOAD_URL + Formik?.values?.selfAffidavitDesc}
                                                            alt="Uploaded"
                                                            style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                        />
                                                    )}</th> */}
                                                    <th>
                                                        {Formik?.values?.selfAffidavitDesc && (
                                                            <>
                                                                {Formik.values.selfAffidavitDesc.toLowerCase().endsWith('.pdf') ? (
                                                                    <FaDownload
                                                                        size={25}
                                                                        style={{ cursor: 'pointer', color: '#007bff' }}
                                                                        onClick={() => {
                                                                            const fileUrl = config.url.FILE_DOWNLOAD_URL + Formik.values.selfAffidavitDesc;
                                                                            const link = document.createElement('a');
                                                                            link.href = fileUrl;
                                                                            link.download = Formik.values.selfAffidavitDesc.split('/').pop(); // extract file name
                                                                            document.body.appendChild(link);
                                                                            link.click();
                                                                            document.body.removeChild(link);
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <button
                                                                        onClick={() => ViewImage(Formik.values.selfAffidavitDesc)}
                                                                        style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                                                                    >
                                                                        <img
                                                                            src={config.url.FILE_DOWNLOAD_URL + Formik.values.selfAffidavitDesc}
                                                                            alt="Uploaded"
                                                                            style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                                        />
                                                                    </button>
                                                                    // <SecureImage filePath={filePaths.affidavit} />
                                                                    // <SecureImage filePath={filePaths.affidavit?.filePath} />

                                                                )}
                                                            </>
                                                        )}

                                                    </th>
                                                    {/* <th> {Formik?.values?.selfAffidavitDesc && (
                                                        // <jnb.Button
                                                        //     type="button"
                                                        //     className="btn btn-primary ms-2 p-2 pt-1"
                                                        //     onClick={() => viewImage( Formik?.values?.selfAffidavit)}
                                                        // >
                                                        //     <BsEye className="me-1" />
                                                        //     View
                                                        // </jnb.Button>
                                                        // <img
                                                        //     src={config.url.FILE_DOWNLOAD_URL + Formik?.values?.selfAffidavitDesc}
                                                        //     alt="Uploaded"
                                                        //     style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                        // />
                                                        <SecureImage filePath={filePaths.affidavit} />
                                                    )}</th> */}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Payment(చెల్లింపు)</h1>
                                </div>
                                <jnb.Row className="pt-0">
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                        <p><strong>Years(సంవత్సరాలు):</strong> {Formik.values.workYears} Years</p>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                        <p ><strong>₹Amount(మొత్తం):</strong>₹{Formik.values.amount}</p>
                                    </jnb.Col>
                                </jnb.Row>
                            </jnb.Modal.Body>
                            <jnb.Modal.Footer>
                                <button className="btn btn-secondary"
                                    onClick={() => {
                                        setShowPreviewModal(false);
                                        document.getElementById("form-start").scrollIntoView({ behavior: "smooth" });
                                    }}>Edit
                                </button>
                                <button type="submit" className="btn btn-success"
                                    onClick={() => { submitvalues(Formik.values); }}>
                                    Submit
                                </button>
                            </jnb.Modal.Footer>
                        </jnb.Modal>
                    </jnb.Form>
                </FormikProvider>
            </jnb.Container>
            {/* {selectedImage && (
                <ViewImage
                    fileName={selectedImage}
                    onClose={() => setSelectedImage(null)}
                />
            )} */}
        </React.Fragment>

    )
}